{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCEditorToolBar;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCToolBar,
  WEBLib.TMSFNCTypes, WEBLib.TMSFNCGraphicsTypes;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : first release

  {$IFDEF WEBLIB}
  TMSFNCTOOLBARBOLDSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNC'
           +'Igdmlld0JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkJvb'
           +'GQ8L3RpdGxlPjxnIGlkPSJJY29uIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03LDE3VjJoNC44NWE1LjU1LDUuNTUsMCwwLDEsMy40Mi45'
           +'MiwzLjA3LDMuMDcsMCwwLDEsMS4yLDIuNTksMy4zLDMuMywwLDAsMS0uNzMsMi4xM0EzLjY2LDMuNjYsMCwwLDEsMTMuODgsOC45VjlBMy4'
           +'0OCwzLjQ4LDAsMCwxLDE3LDEyLjUyYTQuMjMsNC4yMywwLDAsMS0xLjMxLDMuMjdBNSw1LDAsMCwxLDEyLjEyLDE3Wk0xMCw0LjQ5VjguMD'
           +'VoMS4zMmEyLDIsMCwwLDAsMS40Ni0uNTEsMS44MiwxLjgyLDAsMCwwLC41My0xLjRxMC0xLjY1LTIuMTktMS42NVptMCw2LjA3djMuOTVoM'
           +'S42MkEyLjMxLDIuMzEsMCwwLDAsMTMuMjUsMTRhMS45MiwxLjkyLDAsMCwwLC41OS0xLjQ5LDEuNzcsMS43NywwLDAsMC0uNTgtMS40MSwy'
           +'LjM1LDIuMzUsMCwwLDAtMS42Mi0uNTFaIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARBOLDSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3'
           +'d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jb'
           +'HMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0'
           +'eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY'
           +'4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbH'
           +'MtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlc'
           +'m4+PC9kZWZzPjx0aXRsZT5Cb2xkPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNNywxN1YyaDQuODVhNS41'
           +'NSw1LjU1LDAsMCwxLDMuNDIuOTIsMy4wNywzLjA3LDAsMCwxLDEuMiwyLjU5LDMuMywzLjMsMCwwLDEtLjczLDIuMTNBMy42NiwzLjY2LDA'
           +'sMCwxLDEzLjg4LDguOVY5QTMuNDgsMy40OCwwLDAsMSwxNywxMi41MmE0LjIzLDQuMjMsMCwwLDEtMS4zMSwzLjI3QTUsNSwwLDAsMSwxMi'
           +'4xMiwxN1pNMTAsNC40OVY4LjA1aDEuMzJhMiwyLDAsMCwwLDEuNDYtLjUxLDEuODIsMS44MiwwLDAsMCwuNTMtMS40cTAtMS42NS0yLjE5L'
           +'TEuNjVabTAsNi4wN3YzLjk1aDEuNjJBMi4zMSwyLjMxLDAsMCwwLDEzLjI1LDE0YTEuOTIsMS45MiwwLDAsMCwuNTktMS40OSwxLjc3LDEu'
           +'NzcsMCwwLDAtLjU4LTEuNDEsMi4zNSwyLjM1LDAsMCwwLTEuNjItLjUxWiIvPjwvZz48L3N2Zz4=';

  TMSFNCTOOLBARITALICSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0'
    +'JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkl0YWxpYzwvdGl0'
    +'bGU+PGcgaWQ9Ikljb24iPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEzLDE2LjU5bC0uMS40MUg3LjM3bC4xNC0uNDFhMy4xNSwzLjE1LDAsMC'
    +'wwLDEuMDktLjE1LDEuNDQsMS40NCwwLDAsMCwuNjUtLjUyLDcuNjcsNy42NywwLDAsMCwuNjctMS44NmwyLjMzLTlhNy4yOSw3LjI5LDAsMCww'
    +'LC4zLTEuNy44My44MywwLDAsMC0uMTMtLjQ5QS43OC43OCwwLDAsMCwxMiwyLjUxYTMuMjcsMy4yNywwLDAsMC0xLS4xTDExLjEzLDJoNS4xOG'
    +'wtLjExLjQxYTIsMiwwLDAsMC0uOTQuMTUsMS42LDEuNiwwLDAsMC0uNjguNjNBMTAuMjYsMTAuMjYsMCwwLDAsMTQsNWwtMi4zMiw5LjA1YTku'
    +'MTksOS4xOSwwLDAsMC0uMzIsMS41OS44MS44MSwwLDAsMCwuMTMuNDcuNzYuNzYsMCwwLDAsLjM5LjNBNC42Nyw0LjY3LDAsMCwwLDEzLDE2Lj'
    +'U5WiIvPjwvZz48L3N2Zz4=';
  TMSFNCTOOLBARITALICSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm'
    +'9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsO'
    +'m5vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJu'
    +'IGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiB'
    +'wYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZW'
    +'lnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5JdGFsa'
    +'WM8L3RpdGxlPjxnIGlkPSJJY29uIj48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xMywxNi41OWwtLjEuNDFINy4zN2wuMTQtLjQxYTMuMTUsMy4x'
    +'NSwwLDAsMCwxLjA5LS4xNSwxLjQ0LDEuNDQsMCwwLDAsLjY1LS41Miw3LjY3LDcuNjcsMCwwLDAsLjY3LTEuODZsMi4zMy05YTcuMjksNy4yOSw'
    +'wLDAsMCwuMy0xLjcuODMuODMsMCwwLDAtLjEzLS40OUEuNzguNzgsMCwwLDAsMTIsMi41MWEzLjI3LDMuMjcsMCwwLDAtMS0uMUwxMS4xMywyaD'
    +'UuMThsLS4xMS40MWEyLDIsMCwwLDAtLjk0LjE1LDEuNiwxLjYsMCwwLDAtLjY4LjYzQTEwLjI2LDEwLjI2LDAsMCwwLDE0LDVsLTIuMzIsOS4wN'
    +'WE5LjE5LDkuMTksMCwwLDAtLjMyLDEuNTkuODEuODEsMCwwLDAsLjEzLjQ3Ljc2Ljc2LDAsMCwwLC4zOS4zQTQuNjcsNC42NywwLDAsMCwxMywx'
    +'Ni41OVoiLz48L2c+PC9zdmc+';

  TMSFNCTOOLBARUNDERLINESVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlVuZGVybGluZTwvdGl0bGU+PGcga'
    +'WQ9Ikljb24iPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE3LDEwLjc5UTE3LDE3LDExLjM4LDE3LDYsMTcsNiwxMVYySDguMzR2OC41MnEwLDQuMzQsMy'
    +'4yMiw0LjM0dDMuMS00LjE5VjJIMTdaIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI1IiB5PSIxOCIgd2lkdGg9IjEzIiBoZWlnaHQ9IjIiLz48L2c+PC9'
    +'zdmc+';
  TMSFNCTOOLBARUNDERLINESVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5VbmRlcmxpbmU8L3RpdGxlPjxnIGlkPSJJY29uIj48c'
    +'GF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xNywxMC43OVExNywxNywxMS4zOCwxNyw2LDE3LDYsMTFWMkg4LjM0djguNTJxMCw0LjM0LDMuMjIsNC4zNHQzLj'
    +'EtNC4xOVYySDE3WiIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iNSIgeT0iMTgiIHdpZHRoPSIxMyIgaGVpZ2h0PSIyIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARSTRIKEOUTSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlN0cmlrZW91dDwvdGl0bGU+PGcga'
    +'WQ9Ikljb24iPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTguMDUsMTYuMThWMTMuN2E0LjEzLDQuMTMsMCwwLDAsLjc2LjU1LDUuNzksNS43OSwwLDAsMC'
    +'wuOTUuNDEsOSw5LDAsMCwwLDEsLjI2LDUuMTksNS4xOSwwLDAsMCwuOTIuMDksMy43NCwzLjc0LDAsMCwwLDIuMTctLjUxQTEuNjksMS42OSwwLDAsMCw'
    +'xNC41NiwxM2ExLjYyLDEuNjIsMCwwLDAtLjI0LS44OSwyLjU2LDIuNTYsMCwwLDAtLjY2LS43LDcuMjgsNy4yOCwwLDAsMC0xLS42bC0xLjI1LS42Yy0u'
    +'NDctLjI2LS45MS0uNTMtMS4zMi0uOEE1LjYsNS42LDAsMCwxLDksOC41NGEzLjY1LDMuNjUsMCwwLDEtLjcxLTEuMUEzLjgzLDMuODMsMCwwLDEsOCw2Y'
    +'TMuNTEsMy41MSwwLDAsMSwuNDQtMS43OEEzLjg2LDMuODYsMCwwLDEsOS42NSwzYTUuMzEsNS4zMSwwLDAsMSwxLjY2LS43M0E3LjQyLDcuNDIsMCwwLD'
    +'EsMTMuMiwyYTcuMjMsNy4yMywwLDAsMSwzLjE5LjUyVjQuODlBNSw1LDAsMCwwLDEzLjMzLDRhNS4wNSw1LjA1LDAsMCwwLTEsLjExLDIuNjUsMi42NSw'
    +'wLDAsMC0uOTIuMzMsMS45LDEuOSwwLDAsMC0uNjYuNiwxLjQ3LDEuNDcsMCwwLDAtLjI1Ljg4LDEuNzQsMS43NCwwLDAsMCwuMTkuODQsMi4xMiwyLjEy'
    +'LDAsMCwwLC41Ny42NCw1Ljg3LDUuODcsMCwwLDAsLjkyLjU4bDEuMjUuNmExNS4yNywxNS4yNywwLDAsMSwxLjM4LjgzLDYuNzMsNi43MywwLDAsMSwxL'
    +'jE0LDEsNC4xMyw0LjEzLDAsMCwxLC43OCwxLjE3QTMuNTksMy41OSwwLDAsMSwxNywxM2EzLjY2LDMuNjYsMCwwLDEtLjQzLDEuODYsMy41NCwzLjU0LD'
    +'AsMCwxLTEuMTYsMS4yNCw0LjksNC45LDAsMCwxLTEuNjcuNjksOS4xNiw5LjE2LDAsMCwxLTIsLjIxLDcuNjEsNy42MSwwLDAsMS0uODYtLjA2LDEwLjM'
    +'sMTAuMywwLDAsMS0xLjA1LS4xNiw3Ljg1LDcuODUsMCwwLDEtMS0uMjZBMi45NCwyLjk0LDAsMCwxLDguMDUsMTYuMThaIi8+PHBhdGggY2xhc3M9ImNs'
    +'cy0xIiBkPSJNNywxMlYxMUgxOHYxWiIvPjwvZz48L3N2Zz4=';
  TMSFNCTOOLBARSTRIKEOUTSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5TdHJpa2VvdXQ8L3RpdGxlPjxnIGlkPSJJY29uIj48c'
    +'GF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik04LjA1LDE2LjE4VjEzLjdhNC4xMyw0LjEzLDAsMCwwLC43Ni41NSw1Ljc5LDUuNzksMCwwLDAsLjk1LjQxLDksOS'
    +'wwLDAsMCwxLC4yNiw1LjE5LDUuMTksMCwwLDAsLjkyLjA5LDMuNzQsMy43NCwwLDAsMCwyLjE3LS41MUExLjY5LDEuNjksMCwwLDAsMTQuNTYsMTNhMS4'
    +'2MiwxLjYyLDAsMCwwLS4yNC0uODksMi41NiwyLjU2LDAsMCwwLS42Ni0uNyw3LjI4LDcuMjgsMCwwLDAtMS0uNmwtMS4yNS0uNmMtLjQ3LS4yNi0uOTEt'
    +'LjUzLTEuMzItLjhBNS42LDUuNiwwLDAsMSw5LDguNTRhMy42NSwzLjY1LDAsMCwxLS43MS0xLjFBMy44MywzLjgzLDAsMCwxLDgsNmEzLjUxLDMuNTEsM'
    +'CwwLDEsLjQ0LTEuNzhBMy44NiwzLjg2LDAsMCwxLDkuNjUsM2E1LjMxLDUuMzEsMCwwLDEsMS42Ni0uNzNBNy40Miw3LjQyLDAsMCwxLDEzLjIsMmE3Lj'
    +'IzLDcuMjMsMCwwLDEsMy4xOS41MlY0Ljg5QTUsNSwwLDAsMCwxMy4zMyw0YTUuMDUsNS4wNSwwLDAsMC0xLC4xMSwyLjY1LDIuNjUsMCwwLDAtLjkyLjM'
    +'zLDEuOSwxLjksMCwwLDAtLjY2LjYsMS40NywxLjQ3LDAsMCwwLS4yNS44OCwxLjc0LDEuNzQsMCwwLDAsLjE5Ljg0LDIuMTIsMi4xMiwwLDAsMCwuNTcu'
    +'NjQsNS44Nyw1Ljg3LDAsMCwwLC45Mi41OGwxLjI1LjZhMTUuMjcsMTUuMjcsMCwwLDEsMS4zOC44Myw2LjczLDYuNzMsMCwwLDEsMS4xNCwxLDQuMTMsN'
    +'C4xMywwLDAsMSwuNzgsMS4xN0EzLjU5LDMuNTksMCwwLDEsMTcsMTNhMy42NiwzLjY2LDAsMCwxLS40MywxLjg2LDMuNTQsMy41NCwwLDAsMS0xLjE2LD'
    +'EuMjQsNC45LDQuOSwwLDAsMS0xLjY3LjY5LDkuMTYsOS4xNiwwLDAsMS0yLC4yMSw3LjYxLDcuNjEsMCwwLDEtLjg2LS4wNiwxMC4zLDEwLjMsMCwwLDE'
    +'tMS4wNS0uMTYsNy44NSw3Ljg1LDAsMCwxLTEtLjI2QTIuOTQsMi45NCwwLDAsMSw4LjA1LDE2LjE4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTcs'
    +'MTJWMTFIMTh2MVoiLz48L2c+PC9zdmc+';

  TMSFNCTOOLBARALIGNLEFTSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFsaWduLUxlZnQ8L3RpdGxlPjxnI'
    +'GlkPSJJY29uIj48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjIiIHk9IjQiIHdpZHRoPSIyMSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PS'
    +'IyIiB5PSI5IiB3aWR0aD0iMTUiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMiIgeT0iMTQiIHdpZHRoPSIyMSIgaGVpZ2h0PSIxIi8'
    +'+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIyIiB5PSIxOSIgd2lkdGg9IjE1IiBoZWlnaHQ9IjEiLz48L2c+PC9zdmc+';
  TMSFNCTOOLBARALIGNLEFTSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5BbGlnbi1MZWZ0PC90aXRsZT48ZyBpZD0iSWNvbiI+P'
    +'HJlY3QgY2xhc3M9ImNscy0zIiB4PSIyIiB5PSI0IiB3aWR0aD0iMjEiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMiIgeT0iOSIgd2'
    +'lkdGg9IjE1IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjIiIHk9IjE0IiB3aWR0aD0iMjEiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXN'
    +'zPSJjbHMtMyIgeD0iMiIgeT0iMTkiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARALIGNCENTERSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFsaWduLUNlbnRlcjwvdGl0bGU+P'
    +'GcgaWQ9Ikljb24iPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMSIgeT0iNCIgd2lkdGg9IjIxIiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIH'
    +'g9IjQiIHk9IjkiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxIiB5PSIxNCIgd2lkdGg9IjIxIiBoZWlnaHQ9IjE'
    +'iLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjQiIHk9IjE5IiB3aWR0aD0iMTUiIGhlaWdodD0iMSIvPjwvZz48L3N2Zz4=';
  TMSFNCTOOLBARALIGNCENTERSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5BbGlnbi1DZW50ZXI8L3RpdGxlPjxnIGlkPSJJY29uI'
    +'j48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjEiIHk9IjQiIHdpZHRoPSIyMSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI0IiB5PSI5Ii'
    +'B3aWR0aD0iMTUiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMSIgeT0iMTQiIHdpZHRoPSIyMSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2x'
    +'hc3M9ImNscy0zIiB4PSI0IiB5PSIxOSIgd2lkdGg9IjE1IiBoZWlnaHQ9IjEiLz48L2c+PC9zdmc+';

  TMSFNCTOOLBARALIGNRIGHTSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFsaWduLVJpZ2h0PC90aXRsZT48Z'
    +'yBpZD0iSWNvbiI+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIyIiB5PSI0IiB3aWR0aD0iMjEiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD'
    +'0iOCIgeT0iOSIgd2lkdGg9IjE1IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjIiIHk9IjE0IiB3aWR0aD0iMjEiIGhlaWdodD0iMSI'
    +'vPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iOCIgeT0iMTkiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxIi8+PC9nPjwvc3ZnPg==';
  TMSFNCTOOLBARALIGNRIGHTSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5BbGlnbi1SaWdodDwvdGl0bGU+PGcgaWQ9Ikljb24iP'
    +'jxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMiIgeT0iNCIgd2lkdGg9IjIxIiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjgiIHk9IjkiIH'
    +'dpZHRoPSIxNSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSIyIiB5PSIxNCIgd2lkdGg9IjIxIiBoZWlnaHQ9IjEiLz48cmVjdCBjbGF'
    +'zcz0iY2xzLTMiIHg9IjgiIHk9IjE5IiB3aWR0aD0iMTUiIGhlaWdodD0iMSIvPjwvZz48L3N2Zz4=';

  TMSFNCTOOLBARIMAGESVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiMwZTY1YWY7fS5jbHMtM3tmaWxsOiNmOTk4NDY7fS5jbHMtNHtmaWxsOiNmYWZhZmE7fS5jbHMtNXtmaWxsOnVybCgjTmV3X1BhdHRlcm'
    +'5fU3dhdGNoXzkpO30uY2xzLTZ7ZmlsbDojODViZmVhO30uY2xzLTd7ZmlsbDp1cmwoI05ld19QYXR0ZXJuX1N3YXRjaF81KTt9LmNscy04e2ZpbGw6IzN'
    +'hM2EzODt9PC9zdHlsZT48cGF0dGVybiBpZD0iTmV3X1BhdHRlcm5fU3dhdGNoXzkiIGRhdGEtbmFtZT0iTmV3IFBhdHRlcm4gU3dhdGNoIDkiIHdpZHRo'
    +'PSI2OCIgaGVpZ2h0PSI2OCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgdmlld0JveD0iMCAwIDY4IDY4Ij48cmVjdCBjbGFzcz0iY2xzLTEiI'
    +'HdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PC9wYXR0ZXJuPjxwYXR0ZXJuIG'
    +'lkPSJOZXdfUGF0dGVybl9Td2F0Y2hfNSIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggNSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJ'
    +'uVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+'
    +'PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5JbWFnZTwvdGl0bGU+PGcgaWQ9I'
    +'kljb24iPjxyZWN0IGNsYXNzPSJjbHMtNCIgeD0iMS41IiB5PSI0LjUiIHdpZHRoPSIyMSIgaGVpZ2h0PSIxNiIvPjxjaXJjbGUgY2xhc3M9ImNscy01Ii'
    +'BjeD0iMTgiIGN5PSI4IiByPSIyIi8+PHBvbHlnb24gY2xhc3M9ImNscy02IiBwb2ludHM9IjcgOSAxLjUgMTQuNSAxLjUgMjAuNSAxMi45NyAyMC41IDE'
    +'4LjUgMjAuNSAyMi41IDIwLjUgMjIuNSAxOC41IDE2LjUgMTIuNSAxMy41IDE1LjUgNyA5Ii8+PHBhdGggY2xhc3M9ImNscy03IiBkPSJNMTMuNSwxNC43'
    +'OSw3LDguMjlsLTYsNlYyMUgyM1YxOC4yOWwtNi41LTYuNVpNMTMuMjgsMjBIMlYxNC43MWw1LTUsNS43OSw1Ljc5LjcxLjcxTDE3LjI5LDIwWk0yMiwyM'
    +'EgxOC43MWwtNC41LTQuNSwyLjI5LTIuMjksNS41LDUuNVoiLz48cGF0aCBjbGFzcz0iY2xzLTgiIGQ9Ik0yMywyMUgxVjRIMjNaTTIsMjBIMjJWNUgyWi'
    +'IvPjwvZz48L3N2Zz4=';
  TMSFNCTOOLBARIMAGESVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5JbWFnZTwvdGl0bGU+PGcgaWQ9Ikljb24iPjxwYXRoI'
    +'GNsYXNzPSJjbHMtMyIgZD0iTTEsMTQuMjlWMjFIMjNWNEgxWk0xMy4yOCwyMEgyVjE0LjcxbDUtNSw1Ljc5LDUuNzkuNzEuNzFMMTcuMjksMjBaTTIyLD'
    +'IwSDE4LjcxbC00LjUtNC41LDIuMjktMi4yOSw1LjUsNS41Wk0yMiw1VjE3LjI5bC01LjUtNS41LTMsM0w3LDguMjlsLTUsNVY1WiIvPjxjaXJjbGUgY2x'
    +'hc3M9ImNscy0zIiBjeD0iMTgiIGN5PSI4IiByPSIyIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARINTERNETLINKSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhZmFmYTt9LmNscy0ye2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlP'
    +'kludGVybmV0LUxpbms8L3RpdGxlPjxnIGlkPSJNYXNrIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNi43Nyw5SDcuMjNBMTguODQsMTguODQsMCwwLD'
    +'AsNywxMmEyMC4wOSwyMC4wOSwwLDAsMCwuMjMsM2g5LjU0QTE5LjIyLDE5LjIyLDAsMCwwLDE3LDEyLDE5LjEyLDE5LjEyLDAsMCwwLDE2Ljc3LDlaIi8'
    +'+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTUsMi40N0ExMS4xMiwxMS4xMiwwLDAsMSwxNy42MSw4aDMuNTVBMTAsMTAsMCwwLDAsMTUsMi40N1oiLz48'
    +'cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMS41NCw5SDE3Ljc4QTIwLjU0LDIwLjU0LDAsMCwxLDE4LDEyYTIyLjA3LDIyLjA3LDAsMCwxLS4yMSwzaDMuN'
    +'zVhMTAsMTAsMCwwLDAsMC02WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTYuMjIsOUgyLjQ2YTEwLDEwLDAsMCwwLDAsNkg2LjIzQTE5LjQxLDE5Lj'
    +'QxLDAsMCwxLDYsMTIsMjAuNTQsMjAuNTQsMCwwLDEsNi4yMiw5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIuODQsOEg2LjM5QTExLjc3LDExLjc'
    +'3LDAsMCwxLDguODgsMi41LDEwLjA4LDEwLjA4LDAsMCwwLDIuODQsOFoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMS45MiwyaC0uMTVDMTAsMi4x'
    +'LDguMjEsNC4zNyw3LjQxLDhoOS4xOEMxNS44Miw0LjQ2LDE0LDIsMTEuOTIsMloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yLjg0LDE2QTEwLDEwL'
    +'DAsMCwwLDksMjEuNTR2MEExMS41NywxMS41NywwLDAsMSw2LjQyLDE2WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTksMTkuODlWMTguNTJBMy41LD'
    +'MuNSwwLDAsMSwxMC4wNywxNkg3LjQyQTExLjg3LDExLjg3LDAsMCwwLDksMTkuODlaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTIsMWgtLjI3QTE'
    +'xLDExLDAsMCwwLDksMjIuNThzMC0uMDcsMC0uMXYtLjk0QTEwLDEwLDAsMCwxLDIuODQsMTZINi40MkExMS41NywxMS41NywwLDAsMCw5LDIxLjUxVjE5'
    +'Ljg5QTExLjg3LDExLjg3LDAsMCwxLDcuNDIsMTZoMi42NWEzLjQ5LDMuNDksMCwwLDEsMi40NS0xSDcuMjNBMjAuMDksMjAuMDksMCwwLDEsNywxMmExO'
    +'C44NCwxOC44NCwwLDAsMSwuMjMtM2g5LjU0QTE5LjEyLDE5LjEyLDAsMCwxLDE3LDEyYTE5LjIyLDE5LjIyLDAsMCwxLS4yMywzaDFBMjIuMDcsMjIuMD'
    +'csMCwwLDAsMTgsMTJhMjAuNTQsMjAuNTQsMCwwLDAtLjIyLTNoMy43NmExMCwxMCwwLDAsMSwwLDZoMUExMSwxMSwwLDAsMCwxMiwxWk0yLjQ2LDE1YTE'
    +'wLDEwLDAsMCwxLDAtNkg2LjIyQTIwLjU0LDIwLjU0LDAsMCwwLDYsMTJhMTkuNDEsMTkuNDEsMCwwLDAsLjIzLDNaTTYuMzksOEgyLjg0YTEwLjA4LDEw'
    +'LjA4LDAsMCwxLDYtNS41QTExLjc3LDExLjc3LDAsMCwwLDYuMzksOFptMSwwYy44LTMuNjMsMi42MS01LjksNC4zNi02aC4xNWMyLjEyLDAsMy45LDIuN'
    +'DYsNC42Nyw2Wm0xMC4yLDBBMTEuMTIsMTEuMTIsMCwwLDAsMTUsMi40NywxMCwxMCwwLDAsMSwyMS4xNiw4WiIvPjwvZz48ZyBpZD0iT3ZlcmxheSI+PH'
    +'BhdGggY2xhc3M9ImNscy0yIiBkPSJNMTQuNjksMjNIMTQuMUEyLjMzLDIuMzMsMCwwLDEsMTIsMjAuNSwyLjMzLDIuMzMsMCwwLDEsMTQuMSwxOGgyLjh'
    +'hMS43MywxLjczLDAsMCwxLC42LjEyLDIuMTIsMi4xMiwwLDAsMSwxLjA3Ljg4LDIuODMsMi44MywwLDAsMSwwLDNoMS4xMmEzLjc4LDMuNzgsMCwwLDAs'
    +'MC0zLDMuNjgsMy42OCwwLDAsMC0uNjMtMSwyLjkzLDIuOTMsMCwwLDAtMS41Ni0uOTMsMi45LDIuOSwwLDAsMC0uNi0uMDdIMTQuMUEzLjMyLDMuMzIsM'
    +'CwwLDAsMTEsMjAuNSwzLjMyLDMuMzIsMCwwLDAsMTQuMSwyNEgxNUEyLjg1LDIuODUsMCwwLDAsMTQuNjksMjNaIi8+PHBhdGggY2xhc3M9ImNscy0yIi'
    +'BkPSJNMjAuOSwxN0gyMGEyLjg1LDIuODUsMCwwLDAsLjMxLDFoLjU5QTIuMzMsMi4zMywwLDAsMSwyMywyMC41LDIuMzMsMi4zMywwLDAsMSwyMC45LDI'
    +'zSDE4LjFhMS43MywxLjczLDAsMCwxLS42LS4xMkEyLjEyLDIuMTIsMCwwLDEsMTYuNDMsMjJhMi44MywyLjgzLDAsMCwxLDAtM0gxNS4zMWEzLjc4LDMu'
    +'NzgsMCwwLDAsMCwzLDMuNjgsMy42OCwwLDAsMCwuNjMsMSwyLjkzLDIuOTMsMCwwLDAsMS41Ni45MywyLjksMi45LDAsMCwwLC42LjA3aDIuOEEzLjMyL'
    +'DMuMzIsMCwwLDAsMjQsMjAuNSwzLjMyLDMuMzIsMCwwLDAsMjAuOSwxN1oiLz48L2c+PC9zdmc+';
  TMSFNCTOOLBARINTERNETLINKSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5JbnRlcm5ldC1MaW5rPC90aXRsZT48ZyBpZD0iTWFza'
    +'yI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjEuNTQsOUgxNy43OEEyMC41NCwyMC41NCwwLDAsMSwxOCwxMmEyMi4wNywyMi4wNywwLDAsMS0uMjEsM2'
    +'gzLjc1YTEwLDEwLDAsMCwwLDAtNloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yLjQ2LDE1SDYuMjNBMTkuNDEsMTkuNDEsMCwwLDEsNiwxMmEyMC4'
    +'1NCwyMC41NCwwLDAsMSwuMjItM0gyLjQ2YTEwLDEwLDAsMCwwLDAsNloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik04Ljg4LDIuNWExMC4wOCwxMC4w'
    +'OCwwLDAsMC02LDUuNUg2LjM5QTExLjc3LDExLjc3LDAsMCwxLDguODgsMi41WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIxLjE2LDhBMTAsMTAsM'
    +'CwwLDAsMTUsMi40NywxMS4xMiwxMS4xMiwwLDAsMSwxNy42MSw4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE2LjU5LDhDMTUuODIsNC40NiwxNC'
    +'wyLDExLjkyLDJoLS4xNUMxMCwyLjEsOC4yMSw0LjM3LDcuNDEsOFoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNi43Nyw5SDcuMjNBMTguODQsMTg'
    +'uODQsMCwwLDAsNywxMmEyMC4wOSwyMC4wOSwwLDAsMCwuMjMsM2g5LjU0QTE5LjIyLDE5LjIyLDAsMCwwLDE3LDEyLDE5LjEyLDE5LjEyLDAsMCwwLDE2'
    +'Ljc3LDlaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNOSwyMi41OHMwLS4wNywwLS4xdi0uOTRBMTAsMTAsMCwwLDEsMi44NCwxNkg2LjQyQTExLjU3L'
    +'DExLjU3LDAsMCwwLDksMjEuNTFWMTkuODlBMTEuODcsMTEuODcsMCwwLDEsNy40MiwxNmgyLjY1YTMuNDksMy40OSwwLDAsMSwyLjQ1LTFINy4yM0EyMC'
    +'4wOSwyMC4wOSwwLDAsMSw3LDEyYTE4Ljg0LDE4Ljg0LDAsMCwxLC4yMy0zaDkuNTRBMTkuMTIsMTkuMTIsMCwwLDEsMTcsMTJhMTkuMjIsMTkuMjIsMCw'
    +'wLDEtLjIzLDNoMUEyMi4wNywyMi4wNywwLDAsMCwxOCwxMmEyMC41NCwyMC41NCwwLDAsMC0uMjItM2gzLjc2YTEwLDEwLDAsMCwxLDAsNmgxQTExLDEx'
    +'LDAsMCwwLDEyLDFoLS4yN0ExMSwxMSwwLDAsMCw5LDIyLjU4Wk0yMS4xNiw4SDE3LjYxQTExLjEyLDExLjEyLDAsMCwwLDE1LDIuNDcsMTAsMTAsMCwwL'
    +'DEsMjEuMTYsOFpNMTEuNzcsMmguMTVjMi4xMiwwLDMuOSwyLjQ2LDQuNjcsNkg3LjQxQzguMjEsNC4zNywxMCwyLjEsMTEuNzcsMlpNOC44OCwyLjVBMT'
    +'EuNzcsMTEuNzcsMCwwLDAsNi4zOSw4SDIuODRBMTAuMDgsMTAuMDgsMCwwLDEsOC44OCwyLjVaTTYuMjIsOUEyMC41NCwyMC41NCwwLDAsMCw2LDEyYTE'
    +'5LjQxLDE5LjQxLDAsMCwwLC4yMywzSDIuNDZhMTAsMTAsMCwwLDEsMC02WiIvPjwvZz48ZyBpZD0iT3ZlcmxheSI+PHBhdGggY2xhc3M9ImNscy0zIiBk'
    +'PSJNMTQuNjksMjNIMTQuMUEyLjMzLDIuMzMsMCwwLDEsMTIsMjAuNSwyLjMzLDIuMzMsMCwwLDEsMTQuMSwxOGgyLjhhMS43MywxLjczLDAsMCwxLC42L'
    +'jEyLDIuMTIsMi4xMiwwLDAsMSwxLjA3Ljg4LDIuODMsMi44MywwLDAsMSwwLDNoMS4xMmEzLjc4LDMuNzgsMCwwLDAsMC0zLDMuNjgsMy42OCwwLDAsMC'
    +'0uNjMtMSwyLjkzLDIuOTMsMCwwLDAtMS41Ni0uOTMsMi45LDIuOSwwLDAsMC0uNi0uMDdIMTQuMUEzLjMyLDMuMzIsMCwwLDAsMTEsMjAuNSwzLjMyLDM'
    +'uMzIsMCwwLDAsMTQuMSwyNEgxNUEyLjg1LDIuODUsMCwwLDAsMTQuNjksMjNaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjAuOSwxN0gyMGEyLjg1'
    +'LDIuODUsMCwwLDAsLjMxLDFoLjU5QTIuMzMsMi4zMywwLDAsMSwyMywyMC41LDIuMzMsMi4zMywwLDAsMSwyMC45LDIzSDE4LjFhMS43MywxLjczLDAsM'
    +'CwxLS42LS4xMkEyLjEyLDIuMTIsMCwwLDEsMTYuNDMsMjJhMi44MywyLjgzLDAsMCwxLDAtM0gxNS4zMWEzLjc4LDMuNzgsMCwwLDAsMCwzLDMuNjgsMy'
    +'42OCwwLDAsMCwuNjMsMSwyLjkzLDIuOTMsMCwwLDAsMS41Ni45MywyLjksMi45LDAsMCwwLC42LjA3aDIuOEEzLjMyLDMuMzIsMCwwLDAsMjQsMjAuNSw'
    +'zLjMyLDMuMzIsMCwwLDAsMjAuOSwxN1oiLz48L2c+PC9zdmc+';

  TMSFNCTOOLBARNUMBERINGSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9LmNscy0ye2ZpbGw6IzFlOGJjZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlP'
    +'k51bWJlcmluZzwvdGl0bGU+PGcgaWQ9Ikljb24iPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iNiIgeT0iNCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjEiLz48cm'
    +'VjdCBjbGFzcz0iY2xzLTEiIHg9IjYiIHk9IjEyIiB3aWR0aD0iMTYiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iNiIgeT0iMjAiIHd'
    +'pZHRoPSIxNiIgaGVpZ2h0PSIxIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNCwyLjI3VjhIMy4xNlYzLjM4YTIuNDgsMi40OCwwLDAsMS0uNDkuMyw0'
    +'LjE4LDQuMTgsMCwwLDEtLjYuMjJWMy4xM0wyLjQ4LDNsLjM4LS4xOC4zOS0uMjMuNC0uMjlaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNSwxNUgxd'
    +'i0uNDZBMS43NywxLjc3LDAsMCwxLDEuMDgsMTRhMi4yLDIuMiwwLDAsMSwuMjMtLjQ2LDMuMjksMy4yOSwwLDAsMSwuMzMtLjQxYy4xMy0uMTMuMjctLj'
    +'I1LjQxLS4zN2wuNDUtLjM1LjQ0LS4zMy4zOC0uMzJhMiwyLDAsMCwwLC4yOC0uMzEsMS41MSwxLjUxLDAsMCwwLC4xOS0uMzUsMS4wOSwxLjA5LDAsMCw'
    +'wLC4wNy0uNCwxLDEsMCwwLDAtLjA4LS40MUEuNy43LDAsMCwwLDMuNTYsMTBhLjg4Ljg4LDAsMCwwLS4zMy0uMTgsMS40MiwxLjQyLDAsMCwwLS40Mi0u'
    +'MDZBMi4wOCwyLjA4LDAsMCwwLDIsMTBhMi42MiwyLjYyLDAsMCwwLS43OC41MVY5LjU0YTMuMjYsMy4yNiwwLDAsMSwuNC0uMjRsLjQxLS4xN0EzLDMsM'
    +'CwwLDEsMi41LDksMy44NCwzLjg0LDAsMCwxLDMsOWEyLjY4LDIuNjgsMCwwLDEsLjc4LjEsMS43LDEuNywwLDAsMSwuNi4zMSwxLjM5LDEuMzksMCwwLD'
    +'EsLjM5LjUxLDEuNzEsMS43MSwwLDAsMSwuMTMuNywyLjE3LDIuMTcsMCwwLDEtLjA5LjY1LDIuNjUsMi42NSwwLDAsMS0uMjcuNTMsMy4xLDMuMSwwLDA'
    +'sMS0uNDMuNDcsNi42NCw2LjY0LDAsMCwxLS41NS40NUwzLDEzLjFjLS4xNy4xMi0uMzIuMjQtLjQ2LjM2YTIuNjUsMi42NSwwLDAsMC0uMzMuMzUuNjEu'
    +'NjEsMCwwLDAtLjEzLjM1djBINVoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xLDIxLjY5di0uODhhMi41LDIuNSwwLDAsMCwxLjQ2LjQ1LDEuODIsM'
    +'S44MiwwLDAsMCwxLS4yNy44LjgsMCwwLDAsLjQtLjcxYzAtLjY2LS41OC0xLTEuNzItMUgxLjY3di0uNzVoLjQ5cTEuNTMsMCwxLjUzLS45M2MwLS41Ny'
    +'0uNC0uODYtMS4xOS0uODZhMi4xMSwyLjExLDAsMCwwLTEuMjUuNDJ2LS44NEEzLjU4LDMuNTgsMCwwLDEsMi44NCwxNmEyLjMxLDIuMzEsMCwwLDEsMS4'
    +'0MS4zOSwxLjE3LDEuMTcsMCwwLDEsLjUzLDFjMCwuNzctLjQ0LDEuMjYtMS4zMywxLjQ4aDBhMS45MSwxLjkxLDAsMCwxLDEuMTMuNDQsMS4yNCwxLjI0'
    +'LDAsMCwxLC40MiwxLDEuNDcsMS40NywwLDAsMS0uNjcsMS4yNkEzLDMsMCwwLDEsMi41NywyMiwzLjMyLDMuMzIsMCwwLDEsMSwyMS42OVoiLz48L2c+P'
    +'C9zdmc+';
  TMSFNCTOOLBARNUMBERINGSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5OdW1iZXJpbmc8L3RpdGxlPjxnIGlkPSJJY29uIj48c'
    +'mVjdCBjbGFzcz0iY2xzLTMiIHg9IjYiIHk9IjQiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSI2IiB5PSIxMiIgd2'
    +'lkdGg9IjE2IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjYiIHk9IjIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMSIvPjxwYXRoIGNsYXN'
    +'zPSJjbHMtMyIgZD0iTTQsMi4yN1Y4SDMuMTZWMy4zOGEyLjQ4LDIuNDgsMCwwLDEtLjQ5LjMsNC4xOCw0LjE4LDAsMCwxLS42LjIyVjMuMTNMMi40OCwz'
    +'bC4zOC0uMTguMzktLjIzLjQtLjI5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTUsMTVIMXYtLjQ2QTEuNzcsMS43NywwLDAsMSwxLjA4LDE0YTIuM'
    +'iwyLjIsMCwwLDEsLjIzLS40NiwzLjI5LDMuMjksMCwwLDEsLjMzLS40MWMuMTMtLjEzLjI3LS4yNS40MS0uMzdsLjQ1LS4zNS40NC0uMzMuMzgtLjMyYT'
    +'IsMiwwLDAsMCwuMjgtLjMxLDEuNTEsMS41MSwwLDAsMCwuMTktLjM1LDEuMDksMS4wOSwwLDAsMCwuMDctLjQsMSwxLDAsMCwwLS4wOC0uNDFBLjcuNyw'
    +'wLDAsMCwzLjU2LDEwYS44OC44OCwwLDAsMC0uMzMtLjE4LDEuNDIsMS40MiwwLDAsMC0uNDItLjA2QTIuMDgsMi4wOCwwLDAsMCwyLDEwYTIuNjIsMi42'
    +'MiwwLDAsMC0uNzguNTFWOS41NGEzLjI2LDMuMjYsMCwwLDEsLjQtLjI0bC40MS0uMTdBMywzLDAsMCwxLDIuNSw5LDMuODQsMy44NCwwLDAsMSwzLDlhM'
    +'i42OCwyLjY4LDAsMCwxLC43OC4xLDEuNywxLjcsMCwwLDEsLjYuMzEsMS4zOSwxLjM5LDAsMCwxLC4zOS41MSwxLjcxLDEuNzEsMCwwLDEsLjEzLjcsMi'
    +'4xNywyLjE3LDAsMCwxLS4wOS42NSwyLjY1LDIuNjUsMCwwLDEtLjI3LjUzLDMuMSwzLjEsMCwwLDEtLjQzLjQ3LDYuNjQsNi42NCwwLDAsMS0uNTUuNDV'
    +'MMywxMy4xYy0uMTcuMTItLjMyLjI0LS40Ni4zNmEyLjY1LDIuNjUsMCwwLDAtLjMzLjM1LjYxLjYxLDAsMCwwLS4xMy4zNXYwSDVaIi8+PHBhdGggY2xh'
    +'c3M9ImNscy0zIiBkPSJNMSwyMS42OXYtLjg4YTIuNSwyLjUsMCwwLDAsMS40Ni40NSwxLjgyLDEuODIsMCwwLDAsMS0uMjcuOC44LDAsMCwwLC40LS43M'
    +'WMwLS42Ni0uNTgtMS0xLjcyLTFIMS42N3YtLjc1aC40OXExLjUzLDAsMS41My0uOTNjMC0uNTctLjQtLjg2LTEuMTktLjg2YTIuMTEsMi4xMSwwLDAsMC'
    +'0xLjI1LjQydi0uODRBMy41OCwzLjU4LDAsMCwxLDIuODQsMTZhMi4zMSwyLjMxLDAsMCwxLDEuNDEuMzksMS4xNywxLjE3LDAsMCwxLC41MywxYzAsLjc'
    +'3LS40NCwxLjI2LTEuMzMsMS40OGgwYTEuOTEsMS45MSwwLDAsMSwxLjEzLjQ0LDEuMjQsMS4yNCwwLDAsMSwuNDIsMSwxLjQ3LDEuNDcsMCwwLDEtLjY3'
    +'LDEuMjZBMywzLDAsMCwxLDIuNTcsMjIsMy4zMiwzLjMyLDAsMCwxLDEsMjEuNjlaIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARINDENTDECREASESVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9LmNscy0ye2ZpbGw6IzFlOGJjZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlP'
    +'kluZGVudC1SaWdodDwvdGl0bGU+PGcgaWQ9Ikljb24iPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMSIgeT0iNCIgd2lkdGg9IjIyIiBoZWlnaHQ9IjEiLz'
    +'48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjEiIHk9IjkiIHdpZHRoPSIxMSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxIiB5PSIxNCI'
    +'gd2lkdGg9IjExIiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjEiIHk9IjE5IiB3aWR0aD0iMjIiIGhlaWdodD0iMSIvPjxwb2x5Z29u'
    +'IGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxOC42MiAxNS41IDE2LjEyIDEzIDIzIDEzIDIzIDEyIDE2LjEyIDEyIDE4LjYyIDkuNSAxNy42MiA4LjUgMTMuN'
    +'jIgMTIuNSAxNy42MiAxNi41IDE4LjYyIDE1LjUiLz48L2c+PC9zdmc+';
  TMSFNCTOOLBARINDENTDECREASESVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5JbmRlbnQtUmlnaHQ8L3RpdGxlPjxnIGlkPSJJY29uI'
    +'j48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjEiIHk9IjQiIHdpZHRoPSIyMiIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxIiB5PSI5Ii'
    +'B3aWR0aD0iMTEiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMSIgeT0iMTQiIHdpZHRoPSIxMSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2x'
    +'hc3M9ImNscy0zIiB4PSIxIiB5PSIxOSIgd2lkdGg9IjIyIiBoZWlnaHQ9IjEiLz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMTguNjIgMTUu'
    +'NSAxNi4xMiAxMyAyMyAxMyAyMyAxMiAxNi4xMiAxMiAxOC42MiA5LjUgMTcuNjIgOC41IDEzLjYyIDEyLjUgMTcuNjIgMTYuNSAxOC42MiAxNS41Ii8+P'
    +'C9nPjwvc3ZnPg==';

  TMSFNCTOOLBARINDENTINCREASESVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9LmNscy0ye2ZpbGw6IzFlOGJjZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlP'
    +'kluZGVudC1MZWZ0PC90aXRsZT48ZyBpZD0iSWNvbiI+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxIiB5PSI0IiB3aWR0aD0iMjIiIGhlaWdodD0iMSIvPj'
    +'xyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTIiIHk9IjkiIHdpZHRoPSIxMSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxMiIgeT0iMTQ'
    +'iIHdpZHRoPSIxMSIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxIiB5PSIxOSIgd2lkdGg9IjIyIiBoZWlnaHQ9IjEiLz48cG9seWdv'
    +'biBjbGFzcz0iY2xzLTIiIHBvaW50cz0iNS4zOCAxNS41IDcuODggMTMgMSAxMyAxIDEyIDcuODggMTIgNS4zOCA5LjUgNi4zOCA4LjUgMTAuMzggMTIuN'
    +'SA2LjM4IDE2LjUgNS4zOCAxNS41Ii8+PC9nPjwvc3ZnPg==';
  TMSFNCTOOLBARINDENTINCREASESVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5JbmRlbnQtTGVmdDwvdGl0bGU+PGcgaWQ9Ikljb24iP'
    +'jxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMSIgeT0iNCIgd2lkdGg9IjIyIiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjEyIiB5PSI5Ii'
    +'B3aWR0aD0iMTEiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMTIiIHk9IjE0IiB3aWR0aD0iMTEiIGhlaWdodD0iMSIvPjxyZWN0IGN'
    +'sYXNzPSJjbHMtMyIgeD0iMSIgeT0iMTkiIHdpZHRoPSIyMiIgaGVpZ2h0PSIxIi8+PHBvbHlnb24gY2xhc3M9ImNscy0zIiBwb2ludHM9IjUuMzggMTUu'
    +'NSA3Ljg4IDEzIDEgMTMgMSAxMiA3Ljg4IDEyIDUuMzggOS41IDYuMzggOC41IDEwLjM4IDEyLjUgNi4zOCAxNi41IDUuMzggMTUuNSIvPjwvZz48L3N2Zz4=';

  TMSFNCTOOLBARCIRCLESVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiI+DQogICA8Y2ly'
    +'Y2xlIGN4PSI2IiBjeT0iNiIgcj0iMyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSI0IiBmaWxsPSJibGFjayIgLz4NCjwvc3ZnPiA=';
  TMSFNCTOOLBARCIRCLESVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiI+DQogICA8Y2ly'
    +'Y2xlIGN4PSI2IiBjeT0iNiIgcj0iMyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI0IiBmaWxsPSJ3aGl0ZSIgLz4NCjwvc3ZnPiA=';

  TMSFNCTOOLBARSQUARESVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiI+DQogIDxyZWN0'
    +'IHg9IjIiIHk9IjIiIHJ4PSIxIiByeT0iMSIgd2lkdGg9IjgiIGhlaWdodD0iOCIgZmlsbD0iYmxhY2siIC8+DQo8L3N2Zz4=';
  TMSFNCTOOLBARSQUARESVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiI+DQogIDxyZWN0'
    +'IHg9IjIiIHk9IjIiIHJ4PSIxIiByeT0iMSIgd2lkdGg9IjgiIGhlaWdodD0iOCIgZmlsbD0id2hpdGUiIC8+DQo8L3N2Zz4=';

  TMSFNCTOOLBARSTARFULLSVGBLACK = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOnVybCgjTmV3X'
    +'1BhdHRlcm5fU3dhdGNoXzEwKTt9LmNscy0ye2ZpbGw6bm9uZTt9LmNscy0ze2ZpbGw6IzNhM2EzODt9LmNscy00e2ZpbGw6IzNhM2EzODt9LmNscy01e2'
    +'ZpbGw6dXJsKCNOZXdfUGF0dGVybl9Td2F0Y2hfMTAtNSk7fS5jbHMtNntjbGlwLXBhdGg6dXJsKCNjbGlwLXBhdGgpO30uY2xzLTd7ZmlsbDp1cmwoI05'
    +'ld19QYXR0ZXJuX1N3YXRjaF85KTt9LmNscy04e2NsaXAtcGF0aDp1cmwoI2NsaXAtcGF0aC0yKTt9PC9zdHlsZT48cGF0dGVybiBpZD0iTmV3X1BhdHRl'
    +'cm5fU3dhdGNoXzEwIiBkYXRhLW5hbWU9Ik5ldyBQYXR0ZXJuIFN3YXRjaCAxMCIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZ'
    +'XJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3'
    +'M9ImNscy0zIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PHBhdHRlcm4gaWQ9Ik5ld19QYXR0ZXJuX1N3YXRjaF8xMC01IiBkYXRhLW5'
    +'hbWU9Ik5ldyBQYXR0ZXJuIFN3YXRjaCAxMCIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94'
    +'PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0zIiB3aWR0aD0iNjgiI'
    +'GhlaWdodD0iNjgiLz48L3BhdHRlcm4+PGNsaXBQYXRoIGlkPSJjbGlwLXBhdGgiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxMiAyLjQ5ID'
    +'E0LjM2IDkuNSAyMiA5LjUgMTUuODIgMTQuNDQgMTguMzEgMjEuODggMTIgMTcuNTcgNS42OCAyMi4wMyA4LjE4IDE0LjQgMiA5LjUgOS42NCA5LjUgMTI'
    +'gMi40OSIvPjwvY2xpcFBhdGg+PHBhdHRlcm4gaWQ9Ik5ld19QYXR0ZXJuX1N3YXRjaF85IiBkYXRhLW5hbWU9Ik5ldyBQYXR0ZXJuIFN3YXRjaCA5IiB3'
    +'aWR0aD0iNjgiIGhlaWdodD0iNjgiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHZpZXdCb3g9IjAgMCA2OCA2OCI+PHJlY3QgY2xhc3M9ImNsc'
    +'y0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTQiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjwvcGF0dGVybj48Y2xpcF'
    +'BhdGggaWQ9ImNsaXAtcGF0aC0yIj48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iLTIzIC0zLjg3IC0xOS45MyA1LjUgLTEwIDUuNSAtMTguMDM'
    +'gMTEuOTcgLTE0LjggMjEuODQgLTIzIDE2LjA2IC0zMS4yMiAyMiAtMjcuOTcgMTEuOTMgLTM2IDUuNSAtMjYuMDcgNS41IC0yMyAtMy44NyIvPjwvY2xp'
    +'cFBhdGg+PC9kZWZzPjx0aXRsZT5GYXZvdXJpdGUtMjwvdGl0bGU+PGcgaWQ9Ikljb24iPjxwb2x5Z29uIGNsYXNzPSJjbHMtNSIgcG9pbnRzPSIxMiAyL'
    +'jQ5IDE0LjM2IDkuNSAyMiA5LjUgMTUuODIgMTQuNDQgMTguMzEgMjEuODggMTIgMTcuNTcgNS42OCAyMi4wMyA4LjE4IDE0LjQgMiA5LjUgOS42NCA5Lj'
    +'UgMTIgMi40OSIvPjxnIGNsYXNzPSJjbHMtNiI+PHJlY3QgY2xhc3M9ImNscy01IiB4PSItMzgiIHk9Ii01NiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8'
    +'+PHJlY3QgY2xhc3M9ImNscy01IiB4PSItMzgiIHk9Ii01NiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy01IiB4PSItMzgi'
    +'IHk9IjEyIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTUiIHg9Ii0zOCIgeT0iMTIiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2O'
    +'CIvPjwvZz48cGF0aCBjbGFzcz0iY2xzLTciIGQ9Ik00LjczLDIzLjMxLDcuNiwxNC41OC41Nyw5SDkuMjhMMTIsLjkyLDE0LjcyLDloOC43MWwtNyw1Lj'
    +'YxLDIuODUsOC41MkwxMiwxOC4xOFpNMy40MywxMGw1LjMzLDQuMjNMNi42MywyMC43NSwxMiwxN2w1LjM2LDMuNjYtMi4xMi02LjM1TDIwLjU3LDEwSDE'
    +'0TDEyLDQuMDVsLTIsNloiLz48cG9seWdvbiBjbGFzcz0iY2xzLTUiIHBvaW50cz0iLTIzIC0zLjg3IC0xOS45MyA1LjUgLTEwIDUuNSAtMTguMDMgMTEu'
    +'OTcgLTE0LjggMjEuODQgLTIzIDE2LjA2IC0zMS4yMiAyMiAtMjcuOTcgMTEuOTMgLTM2IDUuNSAtMjYuMDcgNS41IC0yMyAtMy44NyIvPjxnIGNsYXNzP'
    +'SJjbHMtOCI+PHJlY3QgY2xhc3M9ImNscy01IiB4PSItMzgiIHk9Ii01NiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy01Ii'
    +'B4PSItMzgiIHk9Ii01NiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy01IiB4PSItMzgiIHk9IjEyIiB3aWR0aD0iNjgiIGh'
    +'laWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTUiIHg9Ii0zOCIgeT0iMTIiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjwvZz48L2c+PC9zdmc+';
  TMSFNCTOOLBARSTARFULLSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntjbGlwLXBhdGg6dXJsKCNjbGlwLXBhdGgpO30uY2xzLTN7ZmlsbDojZmFmYWZhO30uY2xzLTR7Y2xpcC1wYXRoOnVybCgjY2xpcC1wYXRoLTIpO3'
    +'08L3N0eWxlPjxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00LjczLDIzLjMxLDcuNiwxNC41OC41Nyw5SDkuMjh'
    +'MMTIsLjkyLDE0LjcyLDloOC43MWwtNyw1LjYxLDIuODUsOC41MkwxMiwxOC4xOFpNMy40MywxMGw1LjMzLDQuMjNMNi42MywyMC43NSwxMiwxN2w1LjM2'
    +'LDMuNjYtMi4xMi02LjM1TDIwLjU3LDEwSDE0TDEyLDQuMDVsLTIsNloiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoLTIiPjxwYXRoI'
    +'GNsYXNzPSJjbHMtMSIgZD0iTS0zMi4xNiwyMy4zbDMuNjEtMTEuMTlMLTM3LjQyLDVoMTFMLTIzLTUuNDgtMTkuNTcsNWgxMWwtOC44Nyw3LjE0LDMuNi'
    +'wxMUwtMjMsMTYuNjdaTS0zNC41OCw2bDcuMiw1Ljc2LTIuODksOC45NEwtMjMsMTUuNDRsNy4yNiw1LjEyLTIuODgtOC43Niw3LjItNS44aC04Ljg3TC0'
    +'yMy0yLjI3LTI1LjcxLDZaIi8+PC9jbGlwUGF0aD48L2RlZnM+PHRpdGxlPkZhdm91cml0ZS0yPC90aXRsZT48ZyBpZD0iSWNvbiI+PGcgY2xhc3M9ImNs'
    +'cy0yIj48cmVjdCBjbGFzcz0iY2xzLTEiIHg9Ii0zOCIgeT0iLTgiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iL'
    +'TM4IiB5PSItOCIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSItMzgiIHk9Ii04IiB3aWR0aD0iNjgiIGhlaWdodD'
    +'0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9Ii0zOCIgeT0iLTgiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjwvZz48ZyBjbGFzcz0iY2xzLTQiPjx'
    +'yZWN0IGNsYXNzPSJjbHMtMSIgeD0iLTM4IiB5PSItOCIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSItMzgiIHk9'
    +'Ii04IiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9Ii0zOCIgeT0iLTgiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvP'
    +'jxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iLTM4IiB5PSItOCIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PC9nPjwvZz48L3N2Zz4=';

  TMSFNCTOOLBARTICKMARKSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0i'
    +'MCAwIDE2IDE2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlRpY2s8L3RpdGxlPjxnIGlkPSJJY'
    +'29uIj48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNS41IDEzLjI1IDEuMTIgOC44OCAxLjg4IDguMTIgNS41IDExLjc1IDE0LjEyIDMuMTIgMT'
    +'QuODggMy44OCA1LjUgMTMuMjUiLz48L2c+PC9zdmc+';
  TMSFNCTOOLBARTICKMARKSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5UaWNrPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBvbHlnb'
    +'24gY2xhc3M9ImNscy0zIiBwb2ludHM9IjUuNSAxMy4yNSAxLjEyIDguODggMS44OCA4LjEyIDUuNSAxMS43NSAxNC4xMiAzLjEyIDE0Ljg4IDMuODggNS'
    +'41IDEzLjI1Ii8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARARROWSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0i'
    +'MCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFycm93LVJpZ2h0LUJsdWU8L3Rpd'
    +'GxlPjxnIGlkPSJJY29uIj48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjMuMTkgMTEuNSAxNC4yNSAyMC40NCAxMy4zNyAxOS41NiAyMS40Mi'
    +'AxMS41IDEzLjM3IDMuNDQgMTQuMjUgMi41NiAyMy4xOSAxMS41Ii8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIyIiB5PSIxMSIgd2lkdGg9IjIwIiBoZWl'
    +'naHQ9IjEiLz48L2c+PC9zdmc+';
  TMSFNCTOOLBARARROWSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8x'
    +'OTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jb'
    +'HMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dG'
    +'Vybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJ'
    +'TcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9'
    +'ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5BcnJvdy1SaWdodC1CbHVlPC90aXRsZT48ZyBpZD0iS'
    +'WNvbiI+PHBvbHlnb24gY2xhc3M9ImNscy0zIiBwb2ludHM9IjIzLjE5IDExLjUgMTQuMjUgMjAuNDQgMTMuMzcgMTkuNTYgMjEuNDIgMTEuNSAxMy4zNy'
    +'AzLjQ0IDE0LjI1IDIuNTYgMjMuMTkgMTEuNSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMiIgeT0iMTEiIHdpZHRoPSIyMCIgaGVpZ2h0PSIxIi8+PC9'
    +'nPjwvc3ZnPg==';

  TMSFNCTOOLBAROPENSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3Lncz'
           +'Lm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXt'
           +'maWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOiNmOTk4NDY7fS5jbHMtNHtmaWxsOnVybCgjTmV3X1BhdHRlcm'
           +'5fU3dhdGNoXzIpO30uY2xzLTV7ZmlsbDp1cmwoI05ld19QYXR0ZXJuX1N3YXRjaF85KTt9LmNscy02e2ZpbGw6IzFlOGJjZDt9PC9zdHlsZT'
           +'48cGF0dGVybiBpZD0iTmV3X1BhdHRlcm5fU3dhdGNoXzIiIGRhdGEtbmFtZT0iTmV3IFBhdHRlcm4gU3dhdGNoIDIiIHdpZHRoPSI2OCIgaG'
           +'VpZ2h0PSI2OCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgdmlld0JveD0iMCAwIDY4IDY4Ij48cmVjdCBjbGFzcz0iY2xzLTEiIH'
           +'dpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PC9wYXR0ZXJuPjxwYX'
           +'R0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfOSIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggOSIgd2lkdGg9IjY4IiBoZWlnaH'
           +'Q9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdG'
           +'g9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0zIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPj'
           +'x0aXRsZT5PcGVuPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjIgMTkuNDMgOCAxMCAyIDE5Lj'
           +'QzIDIgMTkuNDMiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0xMS41OSw4bC0uMy0uMjlMOC41OSw1SDJWMTkuNDNMOCwxMGg0VjguNUE0Lj'
           +'A3LDQuMDcsMCwwLDEsMTIsOGgtLjQ0WiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtNCIgcG9pbnRzPSIyLjgyIDIwIDE2LjQ1IDIwIDIwLjkxID'
           +'EzIDE3IDEzIDE3IDExIDEyIDExIDguNTUgMTEgMi44MiAyMCIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTguNzksNC41SDEuNVYyMC4yMW'
           +'wuNS0uNzhWNUg4LjU5bDIuNywyLjcxLjMuMjlIMTJhNCw0LDAsMCwxLC4wNy0uNWgtLjMxWiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtNCIgcG'
           +'9pbnRzPSIxLjkxIDIwLjUgMTYuNzMgMjAuNSAyMS41IDEzIDIwLjkxIDEzIDE2LjQ1IDIwIDIuODIgMjAgOC41NSAxMSAxMiAxMSAxMiAxMC'
           +'41IDguMjcgMTAuNSAxLjkxIDIwLjUiLz48cGF0aCBjbGFzcz0iY2xzLTUiIGQ9Ik0yMC45MSwxM2wtNC40Niw3SDIuODJsNS43My05SDEyVj'
           +'EwSDhMMiwxOS40M1Y1SDguNTlsMi43LDIuNzEuMy4yOUgxMmE0LDQsMCwwLDEsLjA3LS41YzAtLjE3LjA3LS4zNC4xMS0uNUgxMkw5LDRIMV'
           +'YyMUgxN2w1LjA5LThIMjAuOTFaIi8+PHBvbHlnb24gY2xhc3M9ImNscy02IiBwb2ludHM9IjE5IDEwIDE5IDExIDI0IDExIDI0IDYgMjMgNi'
           +'AyMyAxMCAxOSAxMCIvPjxwYXRoIGNsYXNzPSJjbHMtNiIgZD0iTTIzLjE1LDEwLjg1LDE5LjM3LDcuMDlBMi44NCwyLjg0LDAsMCwwLDE3Lj'
           +'UsNiwyLjUsMi41LDAsMCwwLDE1LDguNVY5SDE0VjguNUEzLjUsMy41LDAsMCwxLDE3LjUsNWEzLjcyLDMuNzIsMCwwLDEsMi41NywxLjM4bC'
           +'4yNy4yNSwzLjUxLDMuNTJaIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBAROPENSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3Lncz'
           +'Lm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXt'
           +'maWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPj'
           +'xwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZ'
           +'WlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIg'
           +'d2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9'
           +'kZWZzPjx0aXRsZT5PcGVuPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMSwyMUgxN2w1LjA5LThIMjAuOT'
           +'FsLTQuNDYsN0gyLjgybDUuNzMtOUgxMlYxMEg4TDIsMTkuNDNWNUg4LjU5bDIuNywyLjcxLjMuMjlIMTJhNS41MSw1LjUxLDAsMCwxLC4xO'
           +'C0xSDEyTDksNEgxWiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMyIgcG9pbnRzPSIxOSAxMCAxOSAxMSAyNCAxMSAyNCA2IDIzIDYgMjMgMTAg'
           +'MTkgMTAiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yMy4xNSwxMC44NSwxOS4zNyw3LjA5QTIuODQsMi44NCwwLDAsMCwxNy41LDYsMi4'
           +'1LDIuNSwwLDAsMCwxNSw4LjVWOUgxNFY4LjVBMy41LDMuNSwwLDAsMSwxNy41LDVhMy43MiwzLjcyLDAsMCwxLDIuNTcsMS4zOGwuMjcuMj'
           +'UsMy41MSwzLjUyWiIvPjwvZz48L3N2Zz4=';

  TMSFNCTOOLBARSAVESVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOT'
  +'k5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE7fS5jbHMt'
  +'M3tmaWxsOiNhNzRhYjA7fS5jbHMtNHtmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO30uY2xzLTV7ZmlsbDp1cmwoI05ld19QYXR0ZXJuX1N3YXRjaF83KTt9PC9zdHlsZT48cGF0dG'
  +'VybiBpZD0iTmV3X1BhdHRlcm5fU3dhdGNoXzIiIGRhdGEtbmFtZT0iTmV3IFBhdHRlcm4gU3dhdGNoIDIiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VP'
  +'blVzZSIgdmlld0JveD0iMCAwIDY4IDY4Ij48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtMiIgd2lkdGg9IjY4IiBoZWlnaHQ9Ij'
  +'Y4Ii8+PC9wYXR0ZXJuPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfNyIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggNyIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0'
  +'ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0zIi'
  +'B3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5TYXZlPC90aXRsZT48ZyBpZD0iSWNvbiI+PHJlY3QgY2xhc3M9ImNscy00IiB4PSIyIiB5PSIyIiB3aWR0'
  +'aD0iMTkiIGhlaWdodD0iMTkiLz48cGF0aCBjbGFzcz0iY2xzLTUiIGQ9Ik0yMSwzVjIxSDRMMywyMFYzSDIxbTEtMUgyVjIxbDEsMUgyMlYyWiIvPjxwYXRoIGNsYXNzPSJjbHMtNSIgZD0iTT'
  +'E4LDJWMTJINlYySDE4bTEsMEg1VjEzSDE5VjJaIi8+PHBhdGggY2xhc3M9ImNscy01IiBkPSJNMTYsMTZ2NUg2VjE2bTExLTFINXY3SDE3VjE1WiIvPjxwYXRoIGNsYXNzPSJjbHMtNSIgZD0i'
  +'TTEwLDE4djNIOFYxOG0xLjY2LTFIN3Y1aDRWMTdaIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARSAVESVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZ'
  +'y8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE7fS5'
  +'jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y'
  +'2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiB'
  +'oZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5TYXZlPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBhd'
  +'GggY2xhc3M9ImNscy0zIiBkPSJNMjEsM1YyMUg0TDMsMjBWM0gyMW0xLTFIMlYyMWwxLDFIMjJWMloiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xOCwyVjEySDZWMkgxOG0xLDBINVYxM0g'
  +'xOVYyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTE2LDE2djVINlYxNm0xMS0xSDV2N0gxN1YxNVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xMCwxOHYzSDhWMThtMS42Ni0xSDd2N'
  +'Wg0VjE3WiIvPjwvZz48L3N2Zz4=';

  TMSFNCTOOLBARCOPYSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOT'
  +'k5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiM3OTc3NzQ7fS5jbHMt'
  +'M3tmaWxsOiMzYTNhMzg7fS5jbHMtNHtmaWxsOiNmZmY7fS5jbHMtNXtmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzEpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2'
  +'F0Y2hfMSIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjgg'
  +'NjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPj'
  +'x0aXRsZT5Db3B5PC90aXRsZT48ZyBpZD0iSWNvbiI+PHBvbHlnb24gY2xhc3M9ImNscy0zIiBwb2ludHM9IjkgMTggMSAxOCAxIDEgMTQgMSAxNCA1IDkgNSA5IDE4Ii8+PHBvbHlnb24gY2xh'
  +'c3M9ImNscy00IiBwb2ludHM9IjkgNSA5IDE3IDIgMTcgMiAyIDEzIDIgMTMgNSA5IDUiLz48cmVjdCBjbGFzcz0iY2xzLTUiIHg9IjMiIHk9IjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjEiLz48cm'
  +'VjdCBjbGFzcz0iY2xzLTUiIHg9IjMiIHk9IjkiIHdpZHRoPSI2IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTUiIHg9IjMiIHk9IjEzIiB3aWR0aD0iNiIgaGVpZ2h0PSIxIi8+PHJl'
  +'Y3QgY2xhc3M9ImNscy0zIiB4PSIxMCIgeT0iNiIgd2lkdGg9IjEzIiBoZWlnaHQ9IjE3Ii8+PHJlY3QgY2xhc3M9ImNscy00IiB4PSIxMSIgeT0iNyIgd2lkdGg9IjExIiBoZWlnaHQ9IjE1Ii'
  +'8+PHJlY3QgY2xhc3M9ImNscy01IiB4PSIxMiIgeT0iMTAiIHdpZHRoPSI5IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTUiIHg9IjEyIiB5PSIxNCIgd2lkdGg9IjkiIGhlaWdodD0i'
  +'MSIvPjxyZWN0IGNsYXNzPSJjbHMtNSIgeD0iMTIiIHk9IjE4IiB3aWR0aD0iOSIgaGVpZ2h0PSIxIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARCOPYSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZ'
  +'y8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE7fS5'
  +'jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y'
  +'2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiB'
  +'oZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5Db3B5PC90aXRsZT48ZyBpZD0iSWNvbiI+PHBvb'
  +'Hlnb24gY2xhc3M9ImNscy0zIiBwb2ludHM9IjEgMSAxIDE4IDkgMTggOSAxNyAyIDE3IDIgMiAxMyAyIDEzIDUgMTQgNSAxNCAxIDEgMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMyIgeT0'
  +'iNSIgd2lkdGg9IjYiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMyIgeT0iOSIgd2lkdGg9IjYiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMyIgeT0iM'
  +'TMiIHdpZHRoPSI2IiBoZWlnaHQ9IjEiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xMCw2VjIzSDIzVjZaTTIyLDIySDExVjdIMjJaIi8+PHJlY3QgY2xhc3M9ImNscy0zIiB4PSIxMiIgeT0'
  +'iMTAiIHdpZHRoPSI5IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjEyIiB5PSIxNCIgd2lkdGg9IjkiIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMTIiI'
  +'Hk9IjE4IiB3aWR0aD0iOSIgaGVpZ2h0PSIxIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARPASTESVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhl'
    +'aWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiM3OTc3NzQ7fS5jbHMtM3tmaWxsOiNmN2RhOTQ7fS5jbHMtNHtmaWxsO'
    +'iNmYWZhZmE7fS5jbHMtNXtmaWxsOiNmOTk4NDY7fS5jbHMtNntjbGlwLXBhdGg6dXJsKCNjbGlwLXBhdGgpO30uY2xzLTd7ZmlsbDojM2EzYTM4O30uY2xzLTh7ZmlsbDp1cmwoI05ld19QYXR0ZXJuX1'
    +'N3YXRjaF8xKTt9LmNscy05e2ZpbGw6dXJsKCNOZXdfUGF0dGVybl9Td2F0Y2hfOSk7fS5jbHMtMTB7ZmlsbDp1cmwoI05ld19QYXR0ZXJuX1N3YXRjaF8xMCk7fS5jbHMtMTF7ZmlsbDp1cmwoI05ld19'
    +'QYXR0ZXJuX1N3YXRjaF8yKTt9LmNscy0xMntjbGlwLXBhdGg6dXJsKCNjbGlwLXBhdGgtMik7fS5jbHMtMTN7Y2xpcC1wYXRoOnVybCgjY2xpcC1wYXRoLTMpO30uY2xzLTE0e2NsaXAtcGF0aDp1cmwo'
    +'I2NsaXAtcGF0aC00KTt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxMiIgeT0iMTAiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMyIvPjwvY2xpcFBhd'
    +'Gg+PHBhdHRlcm4gaWQ9Ik5ld19QYXR0ZXJuX1N3YXRjaF8xIiBkYXRhLW5hbWU9Ik5ldyBQYXR0ZXJuIFN3YXRjaCAxIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiIHBhdHRlcm5Vbml0cz0idXNlclNwYW'
    +'NlT25Vc2UiIHZpZXdCb3g9IjAgMCA2OCA2OCI+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCI'
    +'vPjwvcGF0dGVybj48cGF0dGVybiBpZD0iTmV3X1BhdHRlcm5fU3dhdGNoXzkiIGRhdGEtbmFtZT0iTmV3IFBhdHRlcm4gU3dhdGNoIDkiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIgcGF0dGVyblVuaXRz'
    +'PSJ1c2VyU3BhY2VPblVzZSIgdmlld0JveD0iMCAwIDY4IDY4Ij48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtNSIgd2lkdGg9IjY4IiBoZ'
    +'WlnaHQ9IjY4Ii8+PC9wYXR0ZXJuPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMTAiIGRhdGEtbmFtZT0iTmV3IFBhdHRlcm4gU3dhdGNoIDEwIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiIH'
    +'BhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHZpZXdCb3g9IjAgMCA2OCA2OCI+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHd'
    +'pZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjwvcGF0dGVybj48cGF0dGVybiBpZD0iTmV3X1BhdHRlcm5fU3dhdGNoXzIiIGRhdGEtbmFtZT0iTmV3IFBhdHRlcm4gU3dhdGNoIDIiIHdpZHRoPSI2OCIgaGVp'
    +'Z2h0PSI2OCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgdmlld0JveD0iMCAwIDY4IDY4Ij48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzP'
    +'SJjbHMtNCIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PC9wYXR0ZXJuPjxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoLTIiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEyLDRhMi4xOSwyLjE5LDAsMCwwLT'
    +'ItMS45MUEyLjE5LDIuMTksMCwwLDAsOCw0SDZWN2g4VjRaIi8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aC0zIj48cmVjdCBjbGFzcz0iY2xzLTEiIHg9Ii0yMyIgeT0iNSIgd2lkdGg'
    +'9IjEzIiBoZWlnaHQ9IjE4Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aC00Ij48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0tMjIuNS0yQTIuNywyLjcsMCwwLDAtMjUtNGEyLjcsMi43'
    +'LDAsMCwwLTIuNSwySC0zMFYyaDEwVi0yWiIvPjwvY2xpcFBhdGg+PC9kZWZzPjx0aXRsZT5QYXN0ZTwvdGl0bGU+PGcgaWQ9Ikljb24iPjxnIGNsYXNzPSJjbHMtNiI+PHJlY3QgY2xhc3M9ImNscy0xI'
    +'iB4PSItMzgiIHk9Ii01NiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy00IiB4PSItMzgiIHk9Ii01NiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9Im'
    +'Nscy0xIiB4PSItMzgiIHk9IjEyIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xzLTQiIHg9Ii0zOCIgeT0iMTIiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjwvZz48cGF0aCB'
    +'jbGFzcz0iY2xzLTciIGQ9Ik0yMiwyM0gxMVY5SDIyWk0xMiwyMmg5VjEwSDEyWiIvPjxyZWN0IGNsYXNzPSJjbHMtOCIgeD0iMTMiIHk9IjEzIiB3aWR0aD0iNyIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xh'
    +'c3M9ImNscy04IiB4PSIxMyIgeT0iMTUiIHdpZHRoPSI3IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTgiIHg9IjEzIiB5PSIxNyIgd2lkdGg9IjciIGhlaWdodD0iMSIvPjxyZWN0IGNsYXNzP'
    +'SJjbHMtOCIgeD0iMTMiIHk9IjE5IiB3aWR0aD0iNyIgaGVpZ2h0PSIxIi8+PHBvbHlnb24gY2xhc3M9ImNscy05IiBwb2ludHM9IjEwIDggMTAgMjEgMSAyMSAxIDQgMTggNCAxOCA4IDEwIDgiLz48cG'
    +'9seWdvbiBjbGFzcz0iY2xzLTEwIiBwb2ludHM9IjEwIDggMTAgMjAgMiAyMCAyIDUgMTcgNSAxNyA4IDEwIDgiLz48cG9seWdvbiBjbGFzcz0iY2xzLTExIiBwb2ludHM9IjEwIDggMTAgMTkgMyAxOSA'
    +'zIDYgMTYgNiAxNiA4IDEwIDgiLz48ZyBjbGFzcz0iY2xzLTEyIj48cmVjdCBjbGFzcz0iY2xzLTEiIHg9Ii0zOCIgeT0iLTU2IiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48cmVjdCBjbGFzcz0iY2xz'
    +'LTQiIHg9Ii0zOCIgeT0iLTU2IiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L2c+PHBhdGggY2xhc3M9ImNscy04IiBkPSJNMTQsN0g1VjNINy4xNEEyLjYsMi42LDAsMCwxLDkuNSwxLjA5LDIuNiwyL'
    +'jYsMCwwLDEsMTEuODYsM0gxNFpNNiw2aDdWNEgxMUwxMSwzLjU4QTEuNjgsMS42OCwwLDAsMCw5LjUsMi4wOSwxLjY4LDEuNjgsMCwwLDAsOCwzLjU4TDgsNEg2WiIvPjxnIGNsYXNzPSJjbHMtMTMiPj'
    +'xyZWN0IGNsYXNzPSJjbHMtMSIgeD0iLTM4IiB5PSItNTYiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtNCIgeD0iLTM4IiB5PSItNTYiIHdpZHRoPSI2OCIgaGVpZ2h0PSI'
    +'2OCIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iLTM4IiB5PSIxMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy00IiB4PSItMzgiIHk9IjEyIiB3aWR0aD0iNjgiIGhlaWdo'
    +'dD0iNjgiLz48L2c+PGcgY2xhc3M9ImNscy0xNCI+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSItMzgiIHk9Ii01NiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy00IiB4PSItM'
    +'zgiIHk9Ii01NiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PC9nPjwvZz48L3N2Zz4=';

  TMSFNCTOOLBARPASTESVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm'
    +'9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5'
    +'vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlk'
    +'PSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0Z'
    +'XJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9Ij'
    +'Y4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5QYXN0ZTwvdGl0bGU'
    +'+PGcgaWQ9Ikljb24iPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTIyLDIzSDExVjlIMjJaTTEyLDIyaDlWMTBIMTJaIi8+PHJlY3QgY2xhc3M9ImNs'
    +'cy0zIiB4PSIxMyIgeT0iMTMiIHdpZHRoPSI3IiBoZWlnaHQ9IjEiLz48cmVjdCBjbGFzcz0iY2xzLTMiIHg9IjEzIiB5PSIxNSIgd2lkdGg9IjciI'
    +'GhlaWdodD0iMSIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgeD0iMTMiIHk9IjE3IiB3aWR0aD0iNyIgaGVpZ2h0PSIxIi8+PHJlY3QgY2xhc3M9ImNscy'
    +'0zIiB4PSIxMyIgeT0iMTkiIHdpZHRoPSI3IiBoZWlnaHQ9IjEiLz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMSA0IDEgMjEgMTAgMjE'
    +'gMTAgMjAgMiAyMCAyIDUgNiA1IDYgNCAxIDQiLz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMTMgNCAxMyA1IDE3IDUgMTcgOCAxOCA4'
    +'IDE4IDQgMTMgNCIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTE0LDdINVYzSDcuMTRBMi42LDIuNiwwLDAsMSw5LjUsMS4wOSwyLjYsMi42LDAsM'
    +'CwxLDExLjg2LDNIMTRaTTYsNmg3VjRIMTFMMTEsMy41OEExLjY4LDEuNjgsMCwwLDAsOS41LDIuMDksMS42OCwxLjY4LDAsMCwwLDgsMy41OEw4LD'
    +'RINloiLz48L2c+PC9zdmc+';

  TMSFNCTOOLBARCUTSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy'
    +'8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS'
    +'5jbHMtMntmaWxsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOiNmOTk4NDY7fS5jbHMtNHtmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzkpO30uY2xzLT'
    +'V7ZmlsbDp1cmwoI05ld19QYXR0ZXJuX1N3YXRjaF8yKTt9LmNscy02e2ZpbGw6IzNhM2EzODt9LmNscy03e2ZpbGw6IzBlNjVhZjt9PC9zdHlsZT48cG'
    +'F0dGVybiBpZD0iTmV3X1BhdHRlcm5fU3dhdGNoXzkiIGRhdGEtbmFtZT0iTmV3IFBhdHRlcm4gU3dhdGNoIDkiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OC'
    +'IgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgdmlld0JveD0iMCAwIDY4IDY4Ij48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI2OCIgaGVpZ2'
    +'h0PSI2OCIvPjxyZWN0IGNsYXNzPSJjbHMtMyIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PC9wYXR0ZXJuPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl'
    +'9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcG'
    +'FjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9Im'
    +'Nscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5DdXQ8L3RpdGxlPjxnIGlkPSJJY29uIj48cGF0aCBjbG'
    +'Fzcz0iY2xzLTQiIGQ9Ik04LjUyLDE2aC4wN2MyLjg3LTIuNzksNy4wOC02LjkzLDcuNjMtNy42M0ExMi41OSwxMi41OSwwLDAsMCwxOCwzLjA2TDcuMz'
    +'ksMTQuOTRaIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNOC41MiwxNmguMDdjMi44Ny0yLjc5LDcuMDgtNi45Myw3LjYzLTcuNjNBMTIuNTksMTIuNT'
    +'ksMCwwLDAsMTgsMy4wNkw3LjM5LDE0Ljk0WiIvPjxwYXRoIGNsYXNzPSJjbHMtNSIgZD0iTTguNTIsMTZoLjA3YzIuODctMi43OSw3LjA4LTYuOTMsNy'
    +'42My03LjYzQTEyLjU5LDEyLjU5LDAsMCwwLDE4LDMuMDZMNy4zOSwxNC45NFoiLz48cGF0aCBjbGFzcz0iY2xzLTYiIGQ9Ik02LDE1bDIuMTMsMkg5cz'
    +'cuMTgtNyw4LThhMTMuMzYsMTMuMzYsMCwwLDAsMi02LDQuNTgsNC41OCwwLDAsMC0uNS0yWk0xNi42MSw4LjY5Yy0uNjIuNzctNS4zLDUuMzYtNy44MS'
    +'w3LjgxSDguMzJMNi43LDE1bDExLjY0LTEzQTQuMTYsNC4xNiwwLDAsMSwxOC41LDMsMTMuMDksMTMuMDksMCwwLDEsMTYuNjEsOC42OVoiLz48cGF0aC'
    +'BjbGFzcz0iY2xzLTYiIGQ9Ik02LjcsMTUsOC4zMiwxNi41SDguOGMyLjUxLTIuNDUsNy4xOS03LDcuODEtNy44MUExMy4wOSwxMy4wOSwwLDAsMCwxOC'
    +'41LDNhNC4xNiw0LjE2LDAsMCwwLS4xNi0xLjA3Wm05LjUyLTYuNmMtLjU1LjctNC43Niw0Ljg0LTcuNjMsNy42M0g4LjUyTDcuMzksMTQuOTQsMTgsMy'
    +'4wNkExMi41OSwxMi41OSwwLDAsMSwxNi4yMiw4LjM3WiIvPjxwYXRoIGNsYXNzPSJjbHMtNSIgZD0iTTE0LjQxLDE2aC4xMkwxNS42MSwxNSw1LDMuMD'
    +'ZBMTIuNTksMTIuNTksMCwwLDAsNi43OCw4LjM3QzcuMzMsOS4wNywxMS41NCwxMy4yMSwxNC40MSwxNloiLz48cGF0aCBjbGFzcz0iY2xzLTYiIGQ9Ik'
    +'00LDNBMTMuMzYsMTMuMzYsMCwwLDAsNiw5Yy44MiwxLDgsOCw4LDhoLjk0TDE3LDE1LDQuNSwxQTQuNTgsNC41OCwwLDAsMCw0LDNaTTE1LjYxLDE1LD'
    +'E0LjUzLDE2aC0uMTJjLTIuODctMi43OS03LjA4LTYuOTMtNy42My03LjYzQTEyLjU5LDEyLjU5LDAsMCwxLDUsMy4wNloiLz48cGF0aCBjbGFzcz0iY2'
    +'xzLTciIGQ9Ik0xMCwxOC41QTQuNSw0LjUsMCwxLDAsNS41LDIzLDQuNTEsNC41MSwwLDAsMCwxMCwxOC41Wm0tNywwQTIuNSwyLjUsMCwxLDEsNS41LD'
    +'IxLDIuNSwyLjUsMCwwLDEsMywxOC41WiIvPjxwYXRoIGNsYXNzPSJjbHMtNyIgZD0iTTE3LjUsMTRBNC41LDQuNSwwLDEsMCwyMiwxOC41LDQuNTEsNC'
    +'41MSwwLDAsMCwxNy41LDE0Wm0wLDdBMi41LDIuNSwwLDEsMSwyMCwxOC41LDIuNSwyLjUsMCwwLDEsMTcuNSwyMVoiLz48L2c+PC9zdmc+';

  TMSFNCTOOLBARCUTSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0'
    +'JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZhZmFmYTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkN1dDwvdGl0bGU+P'
    +'GcgaWQ9Ikljb24iPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE3LjUsMTRhNC40NSw0LjQ1LDAsMCwwLTEuMjIuMTlsLTIuMDctMi4zMUMxNS41'
    +'NSwxMC41NCwxNi43LDkuMzcsMTcsOWExMy4zNiwxMy4zNiwwLDAsMCwyLTYsNC41OCw0LjU4LDAsMCwwLS41LTJsLTcsNy44NEw0LjUsMUE0LjU'
    +'4LDQuNTgsMCwwLDAsNCwzLDEzLjM2LDEzLjM2LDAsMCwwLDYsOWMuMy4zNywxLjQ1LDEuNTQsMi43OSwyLjg4TDYuNzIsMTQuMTlBNC40NSw0Lj'
    +'Q1LDAsMCwwLDUuNSwxNGE0LjU2LDQuNTYsMCwxLDAsNCwyLjVsMi0xLjk0Yy44Mi44MSwxLjU0LDEuNSwyLDEuOTRhNC40OSw0LjQ5LDAsMSwwL'
    +'DQtMi41Wk0xMi4xNyw5LjU5LDE4LDMuMDZhMTIuNTksMTIuNTksMCwwLDEtMS43OCw1LjMxYy0uMjYuMzMtMS4zMywxLjQxLTIuNjgsMi43Nmwt'
    +'MS42OS0xLjlaTTUuNSwyMUEyLjUsMi41LDAsMSwxLDgsMTguNSwyLjUsMi41LDAsMCwxLDUuNSwyMVpNOSwxNS42NUE0LjUxLDQuNTEsMCwwLDA'
    +'sNy43LDE0LjZsMS44LTJoMGwxLjI5LDEuMjhaTTYuNzgsOC4zN0ExMi41OSwxMi41OSwwLDAsMSw1LDMuMDZMMTUuMywxNC42YTQuNTEsNC41MS'
    +'wwLDAsMC0xLjI1LDEuMDVDMTEuMiwxMi44Nyw3LjMxLDksNi43OCw4LjM3Wk0xNy41LDIxQTIuNSwyLjUsMCwxLDEsMjAsMTguNSwyLjUsMi41L'
    +'DAsMCwxLDE3LjUsMjFaIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARUNDOSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdm'
    +'lld0JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlVuZG88L'
    +'3RpdGxlPjxnIGlkPSJJY29uIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNS41LDhIMi44OEw4Ljk0LDEuOTRsLS44OC0uODhMLjYyLDgu'
    +'NWw3LjQ0LDcuNDQuODgtLjg4TDIuODgsOUgxNS41YTYuNSw2LjUsMCwwLDEsLjA2LDEzSDE1djFoLjU2QTcuNSw3LjUsMCwwLDAsMTUuNSw'
    +'4WiIvPjwvZz48L3N2Zz4=';

  TMSFNCTOOLBARUNDOSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5'
    +'L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaW'
    +'xsOiNmYWZhZmE7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hf'
    +'MiIgZGF0YS1uYW1lPSJOZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aW'
    +'V3Qm94PSIwIDAgNjggNjgiPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgi'
    +'IGhlaWdodD0iNjgiLz48L3BhdHRlcm4+PC9kZWZzPjx0aXRsZT5VbmRvPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTUuNS'
    +'w4SDIuODhMOC45NCwxLjk0bC0uODgtLjg4TC42Miw4LjVsNy40NCw3LjQ0Ljg4LS44OEwyLjg4LDlIMTUuNWE2LjUsNi41LDAsMCwxLC4wNiwxM0gxNXYxaC41'
    +'NkE3LjUsNy41LDAsMCwwLDE1LjUsOFoiLz48L2c+PC9zdmc+';

  TMSFNCTOOLBARREDOSVG = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI'
    +'0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlJlZG88L3RpdGxlPjxnIGlkPSJJY29uIj48cGF0aCBjbGFzcz0'
    +'iY2xzLTEiIGQ9Ik0xNS4wNiwxLjk0LDIxLjEyLDhIOC41YTcuNSw3LjUsMCwwLDAtLjA2LDE1SDlWMjJIOC40NEE2LjUsNi41LDAsMCwxLDguNSw5SDIxLjEybC02LjA'
    +'2LDYuMDYuODguODhMMjMuMzgsOC41LDE1Ljk0LDEuMDZaIi8+PC9nPjwvc3ZnPg==';

  TMSFNCTOOLBARREDOSVGWHITE = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5'
    +'rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiNmYWZhZmE'
    +'7fS5jbHMtM3tmaWxsOnVybCgjTmV3X1BhdHRlcm5fU3dhdGNoXzIpO308L3N0eWxlPjxwYXR0ZXJuIGlkPSJOZXdfUGF0dGVybl9Td2F0Y2hfMiIgZGF0YS1uYW1lPSJ'
    +'OZXcgUGF0dGVybiBTd2F0Y2ggMiIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4IiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB2aWV3Qm94PSIwIDAgNjggNjgiPjx'
    +'yZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjY4IiBoZWlnaHQ9IjY4Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiLz48L3BhdHRlcm4'
    +'+PC9kZWZzPjx0aXRsZT5SZWRvPC90aXRsZT48ZyBpZD0iSWNvbiI+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTUuMDYsMS45NCwyMS4xMiw4SDguNWE3LjUsNy41LDA'
    +'sMCwwLS4wNiwxNUg5VjIySDguNDRBNi41LDYuNSwwLDAsMSw4LjUsOUgyMS4xMmwtNi4wNiw2LjA2Ljg4Ljg4TDIzLjM4LDguNSwxNS45NCwxLjA2WiIvPjwvZz48L3N'
    +'2Zz4=';
  {$ENDIF}

type
  TTMSFNCEditorToolBar = class(TTMSFNCToolBar)
  private class var
    FBlockBuildControls: Boolean;
  protected
    function CanBuildControls: Boolean; override;
    function GetVersion: String; override;
    procedure UpdateToolBar; virtual; abstract;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
  public
    class property BlockBuildControls: Boolean read FBlockBuildControls write FBlockBuildControls;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
  end;

  TTMSFNCEditorFormatToolBarApplyFontSize = procedure(Sender: TObject; AFontSize: Integer) of object;
  TTMSFNCEditorFormatToolBarApplyFontName = procedure(Sender: TObject; AFontName: String) of object;
  TTMSFNCEditorFormatToolBarApplyColor = procedure(Sender: TObject; AColor: TTMSFNCGraphicsColor) of object;
  TTMSFNCEditorFormatToolBarApplyBullets = procedure(Sender: TObject; AIndex: Integer) of object;

  TTMSFNCEditorFormatToolBarOption = (ftoFontName, ftoFontSize, ftoBold, ftoItalic, ftoUnderline, ftoStrikeout,
    ftoAlignLeft, ftoAlignCenter, ftoAlignRight, ftoTextColor, ftoBackgroundColor, ftoImage, ftoHyperlink, ftoBullets,
    ftoNumbering, ftoUnindent, ftoIndent);
  TTMSFNCEditorFormatToolBarOptions = set of TTMSFNCEditorFormatToolBarOption;

const
  AllFormatOptions = [Low(TTMSFNCEditorFormatToolBarOption)..High(TTMSFNCEditorFormatToolBarOption)];

type
  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatforms)]
  {$ENDIF}
  TTMSFNCEditorFormatToolBar = class(TTMSFNCEditorToolBar)
  private
    FCreated: Boolean;
    FSep1, FSep2, FSep3, FSep4: TTMSFNCToolBarSeparator;
    FBold, FItalic, FUnderline, FStrikeout, FAlignLeft, FAlignCenter,
    FAlignRight, FUnindent, FIndent, FImage, FNumbering, FHyperlink: TTMSFNCToolBarButton;
    FFontNamePicker: TTMSFNCToolBarFontNamePicker;
    FFontSizePicker: TTMSFNCToolBarFontSizePicker;
    FTextColorPicker, FBackgroundColorPicker: TTMSFNCToolBarColorPicker;
    FBitmapPicker: TTMSFNCToolBarBitmapPicker;
    FOnApplyFontSize: TTMSFNCEditorFormatToolBarApplyFontSize;
    FOnApplyFontName: TTMSFNCEditorFormatToolBarApplyFontName;
    FOnApplyBackgroundColor: TTMSFNCEditorFormatToolBarApplyColor;
    FOnApplyTextColor: TTMSFNCEditorFormatToolBarApplyColor;
    FOnApplyBullets: TTMSFNCEditorFormatToolBarApplyBullets;
    FOnAlignCenter: TNotifyEvent;
    FOnAlignLeft: TNotifyEvent;
    FOnApplyStrikeout: TNotifyEvent;
    FOnApplyBold: TNotifyEvent;
    FOnAlignRight: TNotifyEvent;
    FOnApplyNumbering: TNotifyEvent;
    FOnApplyUnderline: TNotifyEvent;
    FOnApplyItalic: TNotifyEvent;
    FOnInsertHyperlink: TNotifyEvent;
    FOnIndent: TNotifyEvent;
    FOnUnindent: TNotifyEvent;
    FOnInsertBitmap: TNotifyEvent;
    FOptions: TTMSFNCEditorFormatToolBarOptions;
    procedure SetOptions(const Value: TTMSFNCEditorFormatToolBarOptions);
  protected
    procedure UpdateToolBar; override;
    procedure FontName(Sender: TObject);
    procedure FontSize(Sender: TObject);
    procedure TextColor(Sender: TObject);
    procedure Bullets(Sender: TObject);
    procedure BackgroundColor(Sender: TObject);
    procedure BitmapSelected(Sender: TObject; {%H-}ABitmap: TTMSFNCBitmap);
    procedure FontNameSelected(Sender: TObject; {%H-}AFontName: String);
    procedure FontSizeSelected(Sender: TObject; {%H-}AFontSize: Single);
    procedure TextColorSelected(Sender: TObject; {%H-}AColor: TTMSFNCGraphicsColor);
    procedure BackgroundColorSelected(Sender: TObject; {%H-}AColor: TTMSFNCGraphicsColor);
    procedure Bold(Sender: TObject);
    procedure Italic(Sender: TObject);
    procedure InsertHyperlink(Sender: TObject);
    procedure InsertBitmap(Sender: TObject);
    procedure Numbering(Sender: TObject);
    procedure Indent(Sender: TObject);
    procedure Unindent(Sender: TObject);
    procedure Underline(Sender: TObject);
    procedure Strikeout(Sender: TObject);
    procedure AlignLeft(Sender: TObject);
    procedure AlignCenter(Sender: TObject);
    procedure AlignRight(Sender: TObject);

    procedure UpdateOptions; virtual;
    procedure DoApplyFontName(AFontName: String); virtual;
    procedure DoApplyFontSize(AFontSize: Integer); virtual;
    procedure DoApplyBackgroundColor(AColor: TTMSFNCGraphicsColor); virtual;
    procedure DoApplyTextColor(AColor: TTMSFNCGraphicsColor); virtual;
    procedure DoApplyBullets(AIndex: Integer); virtual;
    procedure DoApplyBold; virtual;
    procedure DoApplyItalic; virtual;
    procedure DoInsertHyperlink(AValue: String); virtual;
    procedure DoInsertBitmap(AFileName: String); virtual;
    procedure DoApplyNumbering; virtual;
    procedure DoApplyIndent; virtual;
    procedure DoApplyUnindent; virtual;
    procedure DoApplyUnderline; virtual;
    procedure DoApplyStrikeout; virtual;
    procedure DoAlignLeft; virtual;
    procedure DoAlignCenter; virtual;
    procedure DoAlignRight; virtual;
    function IsCreated: boolean;
  public
    constructor Create(AOwner: TComponent); override;
    function FirstSeparator: TTMSFNCToolBarSeparator;
    function SecondSeparator: TTMSFNCToolBarSeparator;
    function ThirdSeparator: TTMSFNCToolBarSeparator;
    function FourthSeparator: TTMSFNCToolBarSeparator;
    function FontNamePicker: TTMSFNCToolBarFontNamePicker;
    function FontSizePicker: TTMSFNCToolBarFontSizePicker;
    function BackgroundColorPicker: TTMSFNCToolBarColorPicker;
    function TextColorPicker: TTMSFNCToolBarColorPicker;
    function BulletsPicker: TTMSFNCToolBarBitmapPicker;
    function NumberingButton: TTMSFNCToolBarButton;
    function AlignLeftButton: TTMSFNCToolBarButton;
    function AlignCenterButton: TTMSFNCToolBarButton;
    function AlignRightButton: TTMSFNCToolBarButton;
    function StrikeoutButton: TTMSFNCToolBarButton;
    function BoldButton: TTMSFNCToolBarButton;
    function ItalicButton: TTMSFNCToolBarButton;
    function UnderlineButton: TTMSFNCToolBarButton;
    function IndentButton: TTMSFNCToolBarButton;
    function UnindentButton: TTMSFNCToolBarButton;
    function ImageButton: TTMSFNCToolBarButton;
    function HyperlinkButton: TTMSFNCToolBarButton;
  published
    property OnApplyBold: TNotifyEvent read FOnApplyBold write FOnApplyBold;
    property OnApplyItalic: TNotifyEvent read FOnApplyItalic write FOnApplyItalic;
    property OnApplyNumbering: TNotifyEvent read FOnApplyNumbering write FOnApplyNumbering;
    property OnApplyUnderline: TNotifyEvent read FOnApplyUnderline write FOnApplyUnderline;
    property OnApplyStrikeout: TNotifyEvent read FOnApplyStrikeout write FOnApplyStrikeout;
    property OnAlignLeft: TNotifyEvent read FOnAlignLeft write FOnAlignLeft;
    property OnAlignCenter: TNotifyEvent read FOnAlignCenter write FOnAlignCenter;
    property OnAlignRight: TNotifyEvent read FOnAlignRight write FOnAlignRight;
    property OnApplyIndent: TNotifyEvent read FOnIndent write FOnIndent;
    property OnApplyUnindent: TNotifyEvent read FOnUnindent write FOnUnindent;
    property OnInsertHyperlink: TNotifyEvent read FOnInsertHyperlink write FOnInsertHyperlink;
    property OnInsertBitmap: TNotifyEvent read FOnInsertBitmap write FOnInsertBitmap;
    property OnApplyBullets: TTMSFNCEditorFormatToolBarApplyBullets read FOnApplyBullets write FOnApplyBullets;
    property OnApplyFontName: TTMSFNCEditorFormatToolBarApplyFontName read FOnApplyFontName write FOnApplyFontName;
    property OnApplyFontSize: TTMSFNCEditorFormatToolBarApplyFontSize read FOnApplyFontSize write FOnApplyFontSize;
    property OnApplyBackgroundColor: TTMSFNCEditorFormatToolBarApplyColor read FOnApplyBackgroundColor write FOnApplyBackgroundColor;
    property OnApplyTextColor: TTMSFNCEditorFormatToolBarApplyColor read FOnApplyTextColor write FOnApplyTextColor;
    property Options: TTMSFNCEditorFormatToolBarOptions read FOptions write SetOptions default AllFormatOptions;
  end;

  TTMSFNCEditorEditToolBarOption = (etoOpenFile, etoSaveFile, etoCut, etoCopy, etoPaste, etoUndo, etoRedo);
  TTMSFNCEditorEditToolBarOptions = set of TTMSFNCEditorEditToolBarOption;

const
  AllEditOptions = [Low(TTMSFNCEditorEditToolBarOption)..High(TTMSFNCEditorEditToolBarOption)];

type
  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatforms)]
  {$ENDIF}
  TTMSFNCEditorEditToolBar = class(TTMSFNCEditorToolBar)
  private
    FCreated: Boolean;
    FOnSaveFile: TNotifyEvent;
    FOnOpenFile: TNotifyEvent;
    FOnCut: TNotifyEvent;
    FOnPaste: TNotifyEvent;
    FOnUndo: TNotifyEvent;
    FOnRedo: TNotifyEvent;
    FOnCopy: TNotifyEvent;
    FOptions: TTMSFNCEditorEditToolBarOptions;
    FSep1, FSep2: TTMSFNCToolBarSeparator;
    FOpen, FSave, FCut, FCopy, FPaste, FUndo, FRedo: TTMSFNCToolBarButton;
    procedure SetOptions(const Value: TTMSFNCEditorEditToolBarOptions);
  protected
    procedure UpdateToolBar; override;
    procedure OpenFile(Sender: TObject);
    procedure SaveFile(Sender: TObject);
    procedure Cut(Sender: TObject);
    procedure Paste(Sender: TObject);
    procedure Undo(Sender: TObject);
    procedure Redo(Sender: TObject);
    procedure CopyBtn(Sender: TObject);
    procedure UpdateOptions; virtual;
    procedure DoOpenFile(AFileName: String); virtual;
    procedure DoSaveFile(AFileName: String); virtual;
    procedure DoCut; virtual;
    procedure DoPaste; virtual;
    procedure DoUndo; virtual;
    procedure DoRedo; virtual;
    procedure DoCopy; virtual;
    function IsCreated: Boolean;
  public
    constructor Create(AOwner: TComponent); override;
    function FirstSeparator: TTMSFNCToolBarSeparator;
    function SecondSeparator: TTMSFNCToolBarSeparator;
    function OpenFileButton: TTMSFNCToolBarButton;
    function SaveFileButton: TTMSFNCToolBarButton;
    function CutButton: TTMSFNCToolBarButton;
    function CopyButton: TTMSFNCToolBarButton;
    function PasteButton: TTMSFNCToolBarButton;
    function RedoButton: TTMSFNCToolBarButton;
    function UndoButton: TTMSFNCToolBarButton;
  published
    property OnOpenFile: TNotifyEvent read FOnOpenFile write FOnOpenFile;
    property OnSaveFile: TNotifyEvent read FOnSaveFile write FOnSaveFile;
    property OnCut: TNotifyEvent read FOnCut write FOnCut;
    property OnCopy: TNotifyEvent read FOnCopy write FOnCopy;
    property OnPaste: TNotifyEvent read FOnPaste write FOnPaste;
    property OnRedo: TNotifyEvent read FOnRedo write FOnRedo;
    property OnUndo: TNotifyEvent read FOnUndo write FOnUndo;
    property Options: TTMSFNCEditorEditToolBarOptions read FOptions write SetOptions default AllEditOptions;
  end;

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Dialogs, 
  SysUtils, WEBLib.Forms, WEBLib.TMSFNCEditorsTools
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  , UITypes
  {$ENDIF}
  ;

{ TTMSFNCEditorToolBar }

function TTMSFNCEditorToolBar.CanBuildControls: Boolean;
begin
  Result := not FBlockBuildControls;
end;

constructor TTMSFNCEditorToolBar.Create(AOwner: TComponent);
begin
  inherited;
end;

destructor TTMSFNCEditorToolBar.Destroy;
begin
  inherited;
end;

function TTMSFNCEditorToolBar.GetVersion: String;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCEditorToolBar.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
end;

{ TTMSFNCEditorFormatToolBar }

procedure TTMSFNCEditorFormatToolBar.TextColor(Sender: TObject);
var
  c: TTMSFNCGraphicsColor;
begin
  if not Assigned(FTextColorPicker) then
    Exit;

  c := FTextColorPicker.SelectedColor;

  if Assigned(OnApplyTextColor) then
  begin
    OnApplyTextColor(Self, c);
    Exit;
  end;

  DoApplyTextColor(c);
end;

function TTMSFNCEditorFormatToolBar.TextColorPicker: TTMSFNCToolBarColorPicker;
begin
  Result := FTextColorPicker;
end;

procedure TTMSFNCEditorFormatToolBar.BackgroundColor(Sender: TObject);
var
  c: TTMSFNCGraphicsColor;
begin
  if not Assigned(FBackgroundColorPicker) then
    Exit;

  c := FBackgroundColorPicker.SelectedColor;

  if Assigned(OnApplyBackgroundColor) then
  begin
    OnApplyBackgroundColor(Self, c);
    Exit;
  end;

  DoApplyBackgroundColor(c);
end;

function TTMSFNCEditorFormatToolBar.BackgroundColorPicker: TTMSFNCToolBarColorPicker;
begin
  Result := FBackgroundColorPicker;
end;

procedure TTMSFNCEditorFormatToolBar.BackgroundColorSelected(
  Sender: TObject; AColor: TTMSFNCGraphicsColor);
begin
  if Assigned(FBackgroundColorPicker) then
  begin
    if not FBackgroundColorPicker.BlockChange then
      FBackgroundColorPicker.CloseDropDown;

    BackgroundColor(Self);
  end;
end;

constructor TTMSFNCEditorFormatToolBar.Create(AOwner: TComponent);
var
  res: string;
begin
  inherited;
  OptionsMenu.ShowButton := False;
  FOptions := AllFormatOptions;

  FFontNamePicker := AddFontNamePicker;
  FFontNamePicker.AllowFocus := False;
  FFontNamePicker.SelectedItemIndex := 0;
  FFontNamePicker.Stored := False;
  FFontNamePicker.OnClick := FontName;
  FFontNamePicker.OnFontNameSelected := FontNameSelected;

  FFontSizePicker := AddFontSizePicker;
  FFontSizePicker.AllowFocus := False;
  FFontSizePicker.SelectedItemIndex := 0;
  FFontSizePicker.OnClick := FontSize;
  FFontSizePicker.OnFontSizeSelected := FontSizeSelected;
  FFontSizePicker.Stored := False;

  FSep1 := AddSeparator;
  FSep1.AllowFocus := False;
  FSep1.Stored := False;
  FSep1.Height := 24;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARBOLDSVG'
  else
    res := 'TMSFNCTOOLBARBOLDSVGWHITE';
  {$ELSE}
  if IsLightTheme then
    res := TMSFNCTOOLBARBOLDSVG
  else
    res := TMSFNCTOOLBARBOLDSVGWHITE;
  {$ENDIF}

  FBold := AddButton(24, 24, res);
  FBold.AllowFocus := False;
  FBold.AutoOptionsMenuText := 'Bold';
  FBold.Stored := False;
  FBold.OnClick := Bold;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARITALICSVG'
  else
    res := 'TMSFNCTOOLBARITALICSVGWHITE';
  {$ELSE}
  if IsLightTheme then
    res := TMSFNCTOOLBARITALICSVG
  else
    res := TMSFNCTOOLBARITALICSVGWHITE;
  {$ENDIF}

  FItalic := AddButton(24, 24, res);
  FItalic.AllowFocus := False;
  FItalic.AutoOptionsMenuText := 'Italic';
  FItalic.Stored := False;
  FItalic.OnClick := Italic;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARUNDERLINESVG'
  else
    res := 'TMSFNCTOOLBARUNDERLINESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARUNDERLINESVG
  else
    res := TMSFNCTOOLBARUNDERLINESVGWHITE;
  {$ENDIF}
  FUnderline := AddButton(24, 24, res);
  FUnderline.AllowFocus := False;
  FUnderline.AutoOptionsMenuText := 'Underline';
  FUnderline.Stored := False;
  FUnderline.OnClick := Underline;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARSTRIKEOUTSVG'
  else
    res := 'TMSFNCTOOLBARSTRIKEOUTSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARSTRIKEOUTSVG
  else
    res := TMSFNCTOOLBARSTRIKEOUTSVGWHITE;
  {$ENDIF}
  FStrikeout := AddButton(24, 24, res);
  FStrikeout.AllowFocus := False;
  FStrikeout.AutoOptionsMenuText := 'Strikeout';
  FStrikeout.Stored := False;
  FStrikeout.OnClick := Strikeout;

  FSep2 := AddSeparator;
  FSep2.AllowFocus := False;
  FSep2.Stored := False;
  FSep2.Height := 24;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARALIGNLEFTSVG'
  else
    res := 'TMSFNCTOOLBARALIGNLEFTSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARALIGNLEFTSVG
  else
    res := TMSFNCTOOLBARALIGNLEFTSVGWHITE;
  {$ENDIF}
  FAlignLeft := AddButton(24, 24, res);
  FAlignLeft.AllowFocus := False;
  FAlignLeft.Stored := False;
  FAlignLeft.AutoOptionsMenuText := 'Align left';
  FAlignLeft.OnClick := AlignLeft;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARALIGNCENTERSVG'
  else
    res := 'TMSFNCTOOLBARALIGNCENTERSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARALIGNCENTERSVG
  else
    res := TMSFNCTOOLBARALIGNCENTERSVGWHITE;
  {$ENDIF}
  FAlignCenter := AddButton(24, 24, res);
  FAlignCenter.AllowFocus := False;
  FAlignCenter.Stored := False;
  FAlignCenter.AutoOptionsMenuText := 'Align Center';
  FAlignCenter.OnClick := AlignCenter;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARALIGNRIGHTSVG'
  else
    res := 'TMSFNCTOOLBARALIGNRIGHTSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARALIGNRIGHTSVG
  else
    res := TMSFNCTOOLBARALIGNRIGHTSVGWHITE;
  {$ENDIF}
  FAlignRight := AddButton(24, 24, res);
  FAlignRight.AllowFocus := False;
  FAlignRight.AutoOptionsMenuText := 'Align Right';
  FAlignRight.Stored := False;
  FAlignRight.OnClick := AlignRight;

  FSep3 := AddSeparator;
  FSep3.AllowFocus := False;
  FSep3.Stored := False;
  FSep3.Height := 24;

  FTextColorPicker := AddColorPicker;
  FTextColorPicker.AllowFocus := False;
  FTextColorPicker.OnClick := TextColor;
  FTextColorPicker.AutoOptionsMenuText := 'Text Color';
  FTextColorPicker.Stored := False;
  FTextColorPicker.OnColorSelected := TextColorSelected;

  FBackgroundColorPicker := AddColorPicker;
  FBackgroundColorPicker.AllowFocus := False;
  FBackgroundColorPicker.OnClick := BackgroundColor;
  FBackgroundColorPicker.AutoOptionsMenuText := 'Background Color';
  FBackgroundColorPicker.Stored := False;
  FBackgroundColorPicker.OnColorSelected := BackgroundColorSelected;

  FSep4 := AddSeparator;
  FSep4.AllowFocus := False;
  FSep4.Stored := False;
  FSep4.Height := 24;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARIMAGESVG'
  else
    res := 'TMSFNCTOOLBARIMAGESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARIMAGESVG
  else
    res := TMSFNCTOOLBARIMAGESVGWHITE;
  {$ENDIF}
  FImage := AddButton(24, 24, res);
  FImage.AllowFocus := False;
  FImage.AutoOptionsMenuText := 'Insert Image';
  FImage.Stored := False;
  FImage.OnClick := InsertBitmap;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARINTERNETLINKSVG'
  else
    res := 'TMSFNCTOOLBARINTERNETLINKSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARINTERNETLINKSVG
  else
    res := TMSFNCTOOLBARINTERNETLINKSVGWHITE;
  {$ENDIF}
  FHyperlink := AddButton(24, 24, res);
  FHyperlink.AllowFocus := False;
  FHyperlink.AutoOptionsMenuText := 'Insert hyperlink';
  FHyperlink.Stored := False;
  FHyperlink.OnClick := InsertHyperlink;

  FBitmapPicker := AddBitmapPicker;
  FBitmapPicker.AllowFocus := False;
  FBitmapPicker.OnClick := Bullets;
  FBitmapPicker.AutoOptionsMenuText := 'Change Bullet Type';
  FBitmapPicker.Stored := False;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARCIRCLESVG'
  else
    res := 'TMSFNCTOOLBARCIRCLESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARCIRCLESVG
  else
    res := TMSFNCTOOLBARCIRCLESVGWHITE;
  {$ENDIF}
  FBitmapPicker.Items.Add.Bitmap.LoadFromResource(res, HInstance);

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARSQUARESVG'
  else
    res := 'TMSFNCTOOLBARSQUARESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARSQUARESVG
  else
    res := TMSFNCTOOLBARSQUARESVGWHITE;
  {$ENDIF}
  FBitmapPicker.Items.Add.Bitmap.LoadFromResource(res, HInstance);

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARARROWSVG'
  else
    res := 'TMSFNCTOOLBARARROWSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARARROWSVG
  else
    res := TMSFNCTOOLBARARROWSVGWHITE;
  {$ENDIF}
  FBitmapPicker.Items.Add.Bitmap.LoadFromResource(res, HInstance);

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARTICKMARKSVG'
  else
    res := 'TMSFNCTOOLBARTICKMARKSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARTICKMARKSVG
  else
    res := TMSFNCTOOLBARTICKMARKSVGWHITE;
  {$ENDIF}
  FBitmapPicker.Items.Add.Bitmap.LoadFromResource(res, HInstance);

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARSTARFULLSVGBLACK'
  else
    res := 'TMSFNCTOOLBARSTARFULLSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARSTARFULLSVGBLACK
  else
    res := TMSFNCTOOLBARSTARFULLSVGWHITE;
  {$ENDIF}
  FBitmapPicker.Items.Add.Bitmap.LoadFromResource(res, HInstance);

  FBitmapPicker.OnBitmapSelected := BitmapSelected;
  FBitmapPicker.Bitmaps.AddBitmap(FBitmapPicker.Items[0].Bitmap);
  FBitmapPicker.SelectedItemIndex := 0;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARNUMBERINGSVG'
  else
    res := 'TMSFNCTOOLBARNUMBERINGSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARNUMBERINGSVG
  else
    res := TMSFNCTOOLBARNUMBERINGSVGWHITE;
  {$ENDIF}
  FNumbering := AddButton(24, 24, res);
  FNumbering.AllowFocus := False;
  FNumbering.AutoOptionsMenuText := 'Numbering';
  FNumbering.Stored := False;
  FNumbering.OnClick := Numbering;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARINDENTDECREASESVG'
  else
    res := 'TMSFNCTOOLBARINDENTDECREASESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARINDENTDECREASESVG
  else
    res := TMSFNCTOOLBARINDENTDECREASESVGWHITE;
  {$ENDIF}
  FUnindent := AddButton(24, 24, res);
  FUnindent.AllowFocus := False;
  FUnindent.AutoOptionsMenuText := 'Decrease indent';
  FUnindent.Stored := False;
  FUnindent.OnClick := Unindent;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARINDENTINCREASESVG'
  else
    res := 'TMSFNCTOOLBARINDENTINCREASESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARINDENTINCREASESVG
  else
    res := TMSFNCTOOLBARINDENTINCREASESVGWHITE;
  {$ENDIF}
  FIndent := AddButton(24, 24, res);
  FIndent.AllowFocus := False;
  FIndent.AutoOptionsMenuText := 'Increase indent';
  FIndent.Stored := False;
  FIndent.OnClick := Indent;

  FCreated := True;
end;

procedure TTMSFNCEditorFormatToolBar.AlignCenter(Sender: TObject);
begin
  if Assigned(OnAlignCenter) then
  begin
    OnAlignCenter(Self);
    Exit;
  end;

  DoAlignCenter;
end;

function TTMSFNCEditorFormatToolBar.AlignCenterButton: TTMSFNCToolBarButton;
begin
  Result := FAlignCenter;
end;

procedure TTMSFNCEditorFormatToolBar.AlignLeft(Sender: TObject);
begin
  if Assigned(OnAlignLeft) then
  begin
    OnAlignLeft(Self);
    Exit;
  end;

  DoAlignLeft;
end;

function TTMSFNCEditorFormatToolBar.AlignLeftButton: TTMSFNCToolBarButton;
begin
  Result := FAlignLeft;
end;

procedure TTMSFNCEditorFormatToolBar.AlignRight(Sender: TObject);
begin
  if Assigned(OnAlignRight) then
  begin
    OnAlignRight(Self);
    Exit;
  end;

  DoAlignRight;
end;

function TTMSFNCEditorFormatToolBar.AlignRightButton: TTMSFNCToolBarButton;
begin
  Result := FAlignRight;
end;

procedure TTMSFNCEditorFormatToolBar.Bold(Sender: TObject);
begin
  if Assigned(OnApplyBold) then
  begin
    OnApplyBold(Self);
    Exit;
  end;

  DoApplyBold;
end;

function TTMSFNCEditorFormatToolBar.BoldButton: TTMSFNCToolBarButton;
begin
  Result := FBold;
end;

procedure TTMSFNCEditorFormatToolBar.Bullets(Sender: TObject);
var
  c: TTMSFNCGraphicsColor;
begin
  if not Assigned(FBitmapPicker) then
    Exit;

  c := FBitmapPicker.SelectedItemIndex;

  if Assigned(OnApplyBullets) then
  begin
    OnApplyBullets(Self, c);
    Exit;
  end;

  DoApplyBullets(c);
end;

function TTMSFNCEditorFormatToolBar.BulletsPicker: TTMSFNCToolBarBitmapPicker;
begin
  Result := FBitmapPicker;
end;

procedure TTMSFNCEditorFormatToolBar.Indent(Sender: TObject);
begin
  if Assigned(OnApplyIndent) then
  begin
    OnApplyIndent(Self);
    Exit;
  end;

  DoApplyIndent;
end;

function TTMSFNCEditorFormatToolBar.IndentButton: TTMSFNCToolBarButton;
begin
  Result := FIndent;
end;

procedure TTMSFNCEditorFormatToolBar.InsertHyperlink(Sender: TObject);
  {$IFNDEF FMXMOBILE}
var
  {$IFDEF DELPHIBERLIN}
  url: array of string;
  {$ELSE}
  url: string;
  {$ENDIF}
  {$ENDIF}
begin
  if Assigned(OnInsertHyperlink) then
  begin
    OnInsertHyperlink(Self);
    Exit;
  end;

  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  SetLength(url, 1);
  TDialogServiceSync.InputQuery('Hyperlink',['URL'],url);
  DoInsertHyperlink(url[0]);
  {$ELSE}
  url := '';
  InputQuery('Hyperlink','URL',url);
  DoInsertHyperlink(url);
  {$ENDIF}
  {$ENDIF}
end;

function TTMSFNCEditorFormatToolBar.IsCreated: boolean;
begin
  Result := FCreated;
end;

procedure TTMSFNCEditorFormatToolBar.InsertBitmap(Sender: TObject);
{$IFNDEF FMXMOBILE}
var
  od: TOpenDialog;
{$ENDIF}
begin
  if Assigned(OnInsertBitmap) then
  begin
    OnInsertBitmap(Self);
    Exit;
  end;
  {$IFDEF FMXMOBILE}
  DoInsertBitmap('');
  {$ELSE}
  od := TOpenDialog.Create(Self);
  {$IFNDEF WEBLIB}
  od.Filter := 'All (*.gif;*.png;*.jpg;*.jpeg;*.bmp;*.tif;*.tiff;*.ico;*.emf;*.wmf;*.svg)|*.gif;'+
  '*.png;*.jpg;*.jpeg;*.bmp;*.tif;*.tiff;*.ico;*.emf;*.wmf|GIF Bitmap (*.gif)|*.gif|Portable Network Graphics (*.png)|*.png|'+
  'JPEG Bitmap File (*.jpg)|*.jpg|JPEG Bitmap File (*.jpeg)|*.jpeg|Bitmaps (*.bmp)|*.bmp|TIFF Bitmaps (*.tif)|*.tif|TIFF Bitmaps'+
  '(*.tiff)|*.tiff|Icons (*.ico)|*.ico|Enhanced Metafiles (*.emf)|*.emf|Metafiles (*.wmf)|*.wmf|Scalable Vector Graphics (*.svg)|*.svg';
  {$ENDIF}
  try
  {$IFNDEF WEBLIB}
  if od.Execute then
  {$ENDIF}
  {$IFDEF WEBLIB}
  od.Execute(
  procedure(AFileName: string)
  {$ENDIF}
  begin
    DoInsertBitmap(od.FileName);
  end
  {$IFDEF WEBLIB}){$ENDIF};
  finally
    {$IFNDEF WEBLIB}
    od.Free;
    {$ENDIF}
  end;
  {$ENDIF}
end;

procedure TTMSFNCEditorFormatToolBar.Italic(Sender: TObject);
begin
  if Assigned(OnApplyItalic) then
  begin
    OnApplyItalic(Self);
    Exit;
  end;

  DoApplyItalic;
end;

function TTMSFNCEditorFormatToolBar.ItalicButton: TTMSFNCToolBarButton;
begin
  Result := FItalic;
end;

procedure TTMSFNCEditorFormatToolBar.Numbering(Sender: TObject);
begin
  if Assigned(OnApplyNumbering) then
  begin
    OnApplyNumbering(Self);
    Exit;
  end;

  DoApplyNumbering;
end;

function TTMSFNCEditorFormatToolBar.NumberingButton: TTMSFNCToolBarButton;
begin
  Result := FNumbering;
end;

function TTMSFNCEditorFormatToolBar.SecondSeparator: TTMSFNCToolBarSeparator;
begin
  Result := FSep2;
end;

procedure TTMSFNCEditorFormatToolBar.SetOptions(
  const Value: TTMSFNCEditorFormatToolBarOptions);
begin
  if FOptions <> Value then
  begin
    FOptions := Value;
    UpdateOptions;
  end;
end;

procedure TTMSFNCEditorFormatToolBar.Strikeout(Sender: TObject);
begin
  if Assigned(OnApplyStrikeout) then
  begin
    OnApplyStrikeout(Self);
    Exit;
  end;

  DoApplyStrikeout;
end;

function TTMSFNCEditorFormatToolBar.StrikeoutButton: TTMSFNCToolBarButton;
begin
  Result := FStrikeout;
end;

procedure TTMSFNCEditorFormatToolBar.Underline(Sender: TObject);
begin
  if Assigned(OnApplyUnderline) then
  begin
    OnApplyUnderline(Self);
    Exit;
  end;

  DoApplyUnderline;
end;

function TTMSFNCEditorFormatToolBar.UnderlineButton: TTMSFNCToolBarButton;
begin
  Result := FUnderline;
end;

procedure TTMSFNCEditorFormatToolBar.Unindent(Sender: TObject);
begin
  if Assigned(OnApplyUnindent) then
  begin
    OnApplyUnindent(Self);
    Exit;
  end;

  DoApplyUnindent;
end;

function TTMSFNCEditorFormatToolBar.UnindentButton: TTMSFNCToolBarButton;
begin
  Result := FUnindent;
end;

procedure TTMSFNCEditorFormatToolBar.UpdateOptions;
begin
  FBold.Hidden := not (ftoBold in Options);
  FUnderline.Hidden := not (ftoUnderline in Options);
  FStrikeout.Hidden := not (ftoStrikeout in Options);
  FItalic.Hidden := not (ftoItalic in Options);
  FUnindent.Hidden := not (ftoUnindent in Options);
  FIndent.Hidden := not (ftoIndent in Options);
  FFontSizePicker.Hidden := not (ftoFontSize in Options);
  FFontNamePicker.Hidden := not (ftoFontName in Options);
  FAlignLeft.Hidden := not (ftoAlignLeft in Options);
  FAlignCenter.Hidden := not (ftoAlignCenter in Options);
  FAlignRight.Hidden := not (ftoAlignRight in Options);
  FTextColorPicker.Hidden := not (ftoTextColor in Options);
  FBackgroundColorPicker.Hidden := not (ftoBackgroundColor in Options);
  FImage.Hidden := not (ftoImage in Options);
  FHyperlink.Hidden := not (ftoHyperlink in Options);
  FBitmapPicker.Hidden := not (ftoBullets in Options);
  FNumbering.Hidden := not (ftoNumbering in Options);

  if not (csDesigning in ComponentState) then
  begin
    FBold.Visible := (ftoBold in Options);
    FUnderline.Visible := (ftoUnderline in Options);
    FStrikeout.Visible := (ftoStrikeout in Options);
    FItalic.Visible := (ftoItalic in Options);
    FUnindent.Visible := (ftoUnindent in Options);
    FIndent.Visible := (ftoIndent in Options);
    FFontSizePicker.Visible := (ftoFontSize in Options);
    FFontNamePicker.Visible := (ftoFontName in Options);
    FAlignLeft.Visible := (ftoAlignLeft in Options);
    FAlignCenter.Visible := (ftoAlignCenter in Options);
    FAlignRight.Visible := (ftoAlignRight in Options);
    FTextColorPicker.Visible := (ftoTextColor in Options);
    FBackgroundColorPicker.Visible := (ftoBackgroundColor in Options);
    FImage.Visible := (ftoImage in Options);
    FHyperlink.Visible := (ftoHyperlink in Options);
    FBitmapPicker.Visible := (ftoBullets in Options);
    FNumbering.Visible := (ftoNumbering in Options);
  end;
end;

procedure TTMSFNCEditorFormatToolBar.UpdateToolBar;
begin
  if not FCreated then
    Exit;

  Invalidate;
end;

procedure TTMSFNCEditorFormatToolBar.DoAlignCenter;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoAlignLeft;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoAlignRight;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyBackgroundColor(
  AColor: TTMSFNCGraphicsColor);
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyBold;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyBullets(AIndex: Integer);
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyFontName(AFontName: String);
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyFontSize(AFontSize: Integer);
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyIndent;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyItalic;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyNumbering;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyStrikeout;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyTextColor(AColor: TTMSFNCGraphicsColor);
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyUnderline;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoApplyUnindent;
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoInsertHyperlink(AValue: String);
begin
  UpdateToolBar;
end;

procedure TTMSFNCEditorFormatToolBar.DoInsertBitmap(AFileName: String);
begin
  UpdateToolBar;
end;

function TTMSFNCEditorFormatToolBar.FirstSeparator: TTMSFNCToolBarSeparator;
begin
  Result := FSep1;
end;

procedure TTMSFNCEditorFormatToolBar.FontName(Sender: TObject);
var
  fn: String;
begin
  if not Assigned(FFontNamePicker) then
    Exit;

  fn := FFontNamePicker.Text;
  if fn <> '' then
  begin
    if Assigned(OnApplyFontName) then
    begin
      OnApplyFontName(Self, fn);
      Exit;
    end;

    DoApplyFontName(fn);
  end;
end;

function TTMSFNCEditorFormatToolBar.FontNamePicker: TTMSFNCToolBarFontNamePicker;
begin
  Result := FFontNamePicker;
end;

procedure TTMSFNCEditorFormatToolBar.FontNameSelected(Sender: TObject; AFontName: String);
begin
  FontName(Self);
end;

procedure TTMSFNCEditorFormatToolBar.FontSize(Sender: TObject);
var
  fs: Integer;
begin
  if not Assigned(FFontSizePicker) then
    Exit;

  if FFontSizePicker.Text <> '' then
  begin
    fs := StrToInt(FFontSizePicker.Text);


    if Assigned(OnApplyFontSize) then
    begin
      OnApplyFontSize(Self, fs);
      Exit;
    end;

    DoApplyFontSize(fs);
  end;
end;

function TTMSFNCEditorFormatToolBar.FontSizePicker: TTMSFNCToolBarFontSizePicker;
begin
  Result := FFontSizePicker;
end;

procedure TTMSFNCEditorFormatToolBar.FontSizeSelected(Sender: TObject;
  AFontSize: Single);
begin
  FontSize(Self);
end;

function TTMSFNCEditorFormatToolBar.FourthSeparator: TTMSFNCToolBarSeparator;
begin
  Result := FSep4;
end;

function TTMSFNCEditorFormatToolBar.ImageButton: TTMSFNCToolBarButton;
begin
  Result := FImage;
end;

function TTMSFNCEditorFormatToolBar.HyperlinkButton: TTMSFNCToolBarButton;
begin
  Result := FHyperlink;
end;

procedure TTMSFNCEditorFormatToolBar.BitmapSelected(Sender: TObject;
  ABitmap: TTMSFNCBitmap);
begin
  if Assigned(FBitmapPicker) then
  begin
    FBitmapPicker.CloseDropDown;
    Bullets(Self);
  end;
end;

procedure TTMSFNCEditorFormatToolBar.TextColorSelected(Sender: TObject;
  AColor: TTMSFNCGraphicsColor);
begin
  if Assigned(FTextColorPicker) then
  begin
    if not FTextColorPicker.BlockChange then
      FTextColorPicker.CloseDropDown;

    TextColor(Self);
  end;
end;

function TTMSFNCEditorFormatToolBar.ThirdSeparator: TTMSFNCToolBarSeparator;
begin
  Result := FSep3;
end;

{ TTMSFNCEditorEditToolBar }

function TTMSFNCEditorEditToolBar.CopyButton: TTMSFNCToolBarButton;
begin
  Result := FCopy;
end;

constructor TTMSFNCEditorEditToolBar.Create(AOwner: TComponent);
var
  res: String;
begin
  inherited;
  OptionsMenu.ShowButton := False;
  FOptions := AllEditOptions;
  
  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBAROPENSVG'
  else
    res := 'TMSFNCTOOLBAROPENSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBAROPENSVG
  else
    res := TMSFNCTOOLBAROPENSVGWHITE;
  {$ENDIF}
  FOpen := AddButton(24, 24, res);
  FOpen.AllowFocus := False;
  FOpen.AutoOptionsMenuText := 'Open';
  FOpen.Stored := False;
  FOpen.OnClick := OpenFile;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARSAVESVG'
  else
    res := 'TMSFNCTOOLBARSAVESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARSAVESVG
  else
    res := TMSFNCTOOLBARSAVESVGWHITE;
  {$ENDIF}
  FSave := AddButton(24, 24, res);
  FSave.AllowFocus := False;
  FSave.AutoOptionsMenuText := 'Save';
  FSave.Stored := False;
  FSave.OnClick := SaveFile;

  FSep1 := AddSeparator;
  FSep1.AllowFocus := False;
  FSep1.Stored := False;
  FSep1.Height := 24;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARCUTSVG'
  else
    res := 'TMSFNCTOOLBARCUTSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARCUTSVG
  else
    res := TMSFNCTOOLBARCUTSVGWHITE;
  {$ENDIF}
  FCut := AddButton(24, 24, res);
  FCut.AllowFocus := False;
  FCut.AutoOptionsMenuText := 'Cut';
  FCut.Stored := False;
  FCut.OnClick := Cut;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARCOPYSVG'
  else
    res := 'TMSFNCTOOLBARCOPYSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARCOPYSVG
  else
    res := TMSFNCTOOLBARCOPYSVGWHITE;
  {$ENDIF}
  FCopy := AddButton(24, 24, res);
  FCopy.AllowFocus := False;
  FCopy.AutoOptionsMenuText := 'Copy';
  FCopy.Stored := False;
  FCopy.OnClick := CopyBtn;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARPASTESVG'
  else
    res := 'TMSFNCTOOLBARPASTESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARPASTESVG
  else
    res := TMSFNCTOOLBARPASTESVGWHITE;
  {$ENDIF}
  FPaste := AddButton(24, 24, res);
  FPaste.AllowFocus := False;
  FPaste.AutoOptionsMenuText := 'Paste';
  FPaste.Stored := False;
  FPaste.OnClick := Paste;

  FSep2 := AddSeparator;
  FSep2.AllowFocus := False;
  FSep2.Stored := False;
  FSep2.Height := 24;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARUNDOSVG'
  else
    res := 'TMSFNCTOOLBARPASTESVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARUNDOSVG
  else
    res := TMSFNCTOOLBARPASTESVGWHITE;
  {$ENDIF}
  FUndo := AddButton(24, 24, res);
  FUndo.AllowFocus := False;
  FUndo.AutoOptionsMenuText := 'Undo';
  FUndo.Stored := False;
  FUndo.OnClick := Undo;

  {$IFNDEF WEBLIB}
  if IsLightTheme then
    res := 'TMSFNCTOOLBARREDOSVG'
  else
    res := 'TMSFNCTOOLBARREDOSVGWHITE';
  {$ENDIF}
  {$IFDEF WEBLIB}
  if IsLightTheme then
    res := TMSFNCTOOLBARREDOSVG
  else
    res := TMSFNCTOOLBARREDOSVGWHITE;
  {$ENDIF}
  FRedo := AddButton(24, 24, res);
  FRedo.AllowFocus := False;
  FRedo.AutoOptionsMenuText := 'Redo';
  FRedo.Stored := False;
  FRedo.OnClick := Redo;

  FCreated := True;
end;

procedure TTMSFNCEditorEditToolBar.CopyBtn(Sender: TObject);
begin
  if Assigned(OnCopy) then
  begin
    OnCopy(Self);
    Exit;
  end;

  DoCopy;
end;

procedure TTMSFNCEditorEditToolBar.Cut(Sender: TObject);
begin
  if Assigned(OnCut) then
  begin
    OnCut(Self);
    Exit;
  end;

  DoCut;
end;

function TTMSFNCEditorEditToolBar.CutButton: TTMSFNCToolBarButton;
begin
  Result := FCut;
end;

procedure TTMSFNCEditorEditToolBar.DoCopy;
begin

end;

procedure TTMSFNCEditorEditToolBar.DoCut;
begin

end;

procedure TTMSFNCEditorEditToolBar.DoOpenFile(AFileName: String);
begin

end;

procedure TTMSFNCEditorEditToolBar.DoPaste;
begin

end;

procedure TTMSFNCEditorEditToolBar.DoRedo;
begin

end;

procedure TTMSFNCEditorEditToolBar.DoSaveFile(AFileName: String);
begin

end;

procedure TTMSFNCEditorEditToolBar.DoUndo;
begin

end;

function TTMSFNCEditorEditToolBar.FirstSeparator: TTMSFNCToolBarSeparator;
begin
  Result := FSep1;
end;

function TTMSFNCEditorEditToolBar.IsCreated: Boolean;
begin
  Result := FCreated;
end;

procedure TTMSFNCEditorEditToolBar.Paste(Sender: TObject);
begin
  if Assigned(OnPaste) then
  begin
    OnPaste(Self);
    Exit;
  end;

  DoPaste;
end;

function TTMSFNCEditorEditToolBar.PasteButton: TTMSFNCToolBarButton;
begin
  Result := FPaste;
end;

procedure TTMSFNCEditorEditToolBar.Redo(Sender: TObject);
begin
  if Assigned(OnRedo) then
  begin
    OnRedo(Self);
    Exit;
  end;

  DoRedo;
end;

function TTMSFNCEditorEditToolBar.RedoButton: TTMSFNCToolBarButton;
begin
  Result := FRedo;
end;

procedure TTMSFNCEditorEditToolBar.Undo(Sender: TObject);
begin
  if Assigned(OnUndo) then
  begin
    OnUndo(Self);
    Exit;
  end;

  DoUndo;
end;

function TTMSFNCEditorEditToolBar.UndoButton: TTMSFNCToolBarButton;
begin
  Result := FUndo;
end;

procedure TTMSFNCEditorEditToolBar.UpdateOptions;
begin
  FOpen.Hidden := not (etoOpenFile in Options);
  FSave.Hidden := not (etoSaveFile in Options);
  FCut.Hidden := not (etoCut in Options);
  FCopy.Hidden := not (etoCopy in Options);
  FPaste.Hidden := not (etoPaste in Options);
  FUndo.Hidden := not (etoUndo in Options);
  FRedo.Hidden := not (etoRedo in Options);

  if not (csDesigning in ComponentState) then
  begin
    FOpen.Visible := (etoOpenFile in Options);
    FSave.Visible := (etoSaveFile in Options);
    FCut.Visible := (etoCut in Options);
    FCopy.Visible := (etoCopy in Options);
    FPaste.Visible := (etoPaste in Options);
    FUndo.Visible := (etoUndo in Options);
    FRedo.Visible := (etoRedo in Options);
  end;
end;

procedure TTMSFNCEditorEditToolBar.UpdateToolBar;
begin
end;

procedure TTMSFNCEditorEditToolBar.OpenFile(Sender: TObject);
{$IFNDEF FMXMOBILE}
var
  od: TOpenDialog;
{$ENDIF}
begin
  if Assigned(OnOpenFile) then
  begin
    OnOpenFile(Self);
    Exit;
  end;
  {$IFDEF FMXMOBILE}
  DoOpenFile('');
  {$ELSE}
  od := TOpenDialog.Create(Self);
  {$IFNDEF WEBLIB}
  od.Filter := 'Text files|*.txt|RTE files|*.rte|RTF files|*.rtf|All files|*.*';
  od.FilterIndex := 3;
  {$ENDIF}
  try
  {$IFNDEF WEBLIB}
  if od.Execute then
  {$ENDIF}
  {$IFDEF WEBLIB}
  od.Execute(
  procedure(AFileName: string)
  {$ENDIF}
  begin
    DoOpenFile(od.FileName);
  end
  {$IFDEF WEBLIB}){$ENDIF};
  finally
    {$IFNDEF WEBLIB}
    od.Free;
    {$ENDIF}
  end;
  {$ENDIF}
end;

function TTMSFNCEditorEditToolBar.OpenFileButton: TTMSFNCToolBarButton;
begin
  Result := FOpen;
end;

procedure TTMSFNCEditorEditToolBar.SaveFile(Sender: TObject);
{$IFNDEF WEBLIB}
{$IFNDEF FMXMOBILE}
var
  sd: TSaveDialog;
  fe,fn: string;
{$ENDIF}
{$ENDIF}
begin
  if Assigned(OnSaveFile) then
  begin
    OnSaveFile(Self);
    Exit;
  end;
  {$IFDEF WEBLIB}
  DoSaveFile('');
  {$ENDIF}
  {$IFNDEF WEBLIB}
  {$IFDEF FMXMOBILE}

  {$ELSE}
  sd := TSaveDialog.Create(Self);
  sd.Filter := 'Text files|*.txt|RTE files|*.rte|HTML files|*.htm|Rich text|*.rtf';
  sd.DefaultExt := 'txt';
  sd.Options := sd.Options + [TOpenOption.ofOverwritePrompt];
  sd.FilterIndex := 0;
  try
    if sd.Execute then
    begin
      fn := sd.FileName;

      fe := Uppercase(ExtractFileExt(sd.FileName));

      if (fe = '') then
      begin
        if sd.FilterIndex = 0 then
          fn := fn + '.txt';
        if sd.FilterIndex = 1 then
          fn := fn + '.rte';
        if sd.FilterIndex = 2 then
          fn := fn + '.htm';
        if sd.FilterIndex = 3 then
          fn := fn + '.rtf';
      end
      else
      begin
        if fe = '.TXT' then
          sd.FilterIndex := 0;

        if fe = '.RTE' then
          sd.FilterIndex := 1;

        if fe = '.HTM' then
          sd.FilterIndex := 2;

        if fe = '.HTML' then
          sd.FilterIndex := 2;

        if fe = '.RTF' then
          sd.FilterIndex := 3;
      end;
    end;
  finally
    sd.Free;
  end;
  {$ENDIF}
  {$ENDIF}
end;


function TTMSFNCEditorEditToolBar.SaveFileButton: TTMSFNCToolBarButton;
begin
  Result := FSave;
end;

function TTMSFNCEditorEditToolBar.SecondSeparator: TTMSFNCToolBarSeparator;
begin
  Result := FSep2;
end;

procedure TTMSFNCEditorEditToolBar.SetOptions(const Value: TTMSFNCEditorEditToolBarOptions);
begin
  if FOptions <> Value then
  begin
    FOptions := Value;
    UpdateOptions;
  end;
end;

{$IFDEF WEBLIB}
initialization
begin
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARBOLDSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARBOLDSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARITALICSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARITALICSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARUNDERLINESVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARUNDERLINESVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARSTRIKEOUTSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARSTRIKEOUTSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARALIGNLEFTSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARALIGNLEFTSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARALIGNCENTERSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARALIGNCENTERSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARALIGNRIGHTSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARALIGNRIGHTSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARIMAGESVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARIMAGESVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARINTERNETLINKSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARINTERNETLINKSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARNUMBERINGSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARNUMBERINGSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARINDENTDECREASESVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARINDENTDECREASESVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARINDENTINCREASESVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARINDENTINCREASESVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARCIRCLESVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARCIRCLESVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARSQUARESVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARSQUARESVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARSTARFULLSVGBLACK);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARSTARFULLSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARARROWSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARARROWSVGWHITE);

  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBAROPENSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBAROPENSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARSAVESVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARSAVESVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARCUTSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARCUTSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARCOPYSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARCOPYSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARPASTESVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARPASTESVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARUNDOSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARUNDOSVGWHITE);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARREDOSVG);
  TTMSFNCBitmap.CreateFromResource(TMSFNCTOOLBARREDOSVGWHITE);
end;
{$ENDIF}

end.

